<template>
  <div class="main-page">
    <div
      class="head-image"
      :style="
        form.imgsCut
          ? { 'background-image': `url(${form.imgsCut})` }
          : form.imgs
          ? { 'background-image': `url(${form.imgs})` }
          : {
              'background-image': `url(${importTransform()})`
            }
      "
    >
      <div class="head-container"></div>
      <div class="head-tools">
        <div class="upload-tool">
          <el-upload
            class="avatar-uploader"
            :action="action"
            :data="data"
            :show-file-list="false"
            :on-success="handleSuccess"
            :before-upload="beforeUpload"
            :file-list="fileList"
            :accept="'.jpeg,.png,.jpg'"
            ref="upload"
          >
            <!-- <img v-if="form.imgs !== ''" :src="form.imgs" class="avatar" /> -->
            <img
              class="upload-btn"
              @click="addimg()"
              src="~@/assets/images/icons/icon-addimgs.png"
              alt
            />
          </el-upload>
          <p class="upload-remind">
            {{
              hasUploadCover || form.imgs
                ? coverHintHasUpload
                : coverHintNotUpload
            }}
          </p>
          <p class="upload-remind">请上传JPG、JPEG、PNG格式，小于5M的图片</p>
        </div>
        <div class="title-tool">
          <input
            type="text"
            class="travel-title-input"
            :style="{
              color: form.name ? '#000' : '#999',
              border: noTitle ? '1px solid red' : 'none'
            }"
            v-model="form.name"
            maxlength="30"
            placeholder="来给游记配个诱人的标题吧"
          />
        </div>
      </div>
    </div>
    <div
      class="head-cropper"
      v-show="showCropper"
    >
      <div class="cropper">
        <vueCropper
          class="vue-cropper"
          ref="cropper"
          :img="option.img"
          :outputSize="option.size"
          :outputType="option.outputType"
          :info="true"
          :full="option.full"
          :canMove="option.canMove"
          :canMoveBox="option.canMoveBox"
          :autoCrop="option.autoCrop"
          :autoCropWidth="option.autoCropWidth"
          :autoCropHeight="option.autoCropHeight"
          :fixed="option.fixed"
          :fixedNumber="option.fixedNumber"
        ></vueCropper>
      </div>
      <div class="cropper-footer">
        <el-button
          type="info"
          @click="cancleCropper"
        >取消</el-button>
        <el-button
          type="warning"
          @click="submitCropper"
        >确定</el-button>
      </div>
    </div>
    <div class="travel-container">
      <div class="travel-info">
        <div class="travel-attribute">
          <img src="~@/assets/images/write-attribute.png" />
          <div class="travel-attribute-complete">
            完善游记信息，您的游记将会被更多人看见&nbsp;&nbsp;
            <span
              class="travel-attribute-add"
              @click="openAttribute"
            >点击添加</span>
          </div>
        </div>
        <div class="travel-attr-wrap">
          <transition name="fade">
            <div
              class="modal-container"
              v-show="showAttributeEdit"
            >
              <el-form
                :rules="rules"
                ref="ruleFormXX"
                :model="ruleForm"
              >
                <div class="travel-attr-container">
                  <p class="title">你的旅程将会帮助更多的人</p>
                  <p class="space-between">
                    <span class="input-item">
                      <span class="prefix">出游天数</span>
                      <span class="input-content input">
                        <el-form-item
                          label
                          prop="playDays"
                        >
                          <el-input
                            ref="playDays"
                            v-model="ruleForm.playDays"
                            maxlength="9"
                          ></el-input>
                        </el-form-item>
                      </span>
                      <span class="suffix">天</span>
                    </span>
                    <span class="input-item">
                      <span class="prefix">人均消费</span>
                      <span class="input-content input">
                        <el-form-item
                          label
                          prop="price"
                        >
                          <el-input
                            ref="price"
                            v-model="ruleForm.price"
                            maxlength="9"
                          ></el-input>
                        </el-form-item>
                      </span>
                      <span class="suffix">元</span>
                    </span>
                  </p>
                  <p class="no-margin-bottom">
                    <span class="radio-title">自驾玩法</span>
                    <span class="radio-content">
                      <span
                        class="radio"
                        v-for="(item, index) in playWayList"
                        :class="
                          checkInPlayWay(item.value) ? 'radio-checked' : ''
                        "
                        :key="index"
                        @click="checkPlayWay(item)"
                      >{{ item.label }}</span>
                    </span>
                  </p>
                  <p class="no-margin-bottom">
                    <span class="radio-title">和谁去</span>
                    <span class="radio-content">
                      <span
                        class="radio"
                        :class="tourPar == item.code ? 'radio-checked' : ''"
                        :key="index"
                        v-for="(item, index) in partnerList"
                        @click="checkPartner(item)"
                      >{{ item.label }}</span>
                    </span>
                  </p>
                  <p class="no-margin-bottom space-between">
                    <span class="radio-item">
                      <span class="radio-title">驾驶难度</span>
                      <span class="radio-content">
                        <span
                          class="radio"
                          v-for="(item, index) in difficultList"
                          :class="
                            difficulty == item.code ? 'radio-checked' : ''
                          "
                          :key="index"
                          @click="checkDifficult(item)"
                        >{{ item.label }}</span>
                      </span>
                    </span>
                  </p>
                  <p class="no-margin-bottom">
                    <span class="input-item">
                      <span class="prefix">总里程</span>
                      <span class="input-content input large">
                        <el-form-item
                          label
                          prop="totalMileage"
                        >
                          <el-input
                            ref="days"
                            v-model="ruleForm.totalMileage"
                            maxlength="9"
                          ></el-input>
                        </el-form-item>
                      </span>
                      <span class="suffix">公里</span>
                    </span>
                    <span class="input-item">
                      <span class="prefix">出发日期</span>
                      <span class="input-content">
                        <el-form-item
                          label
                          prop="beginDate"
                        >
                          <el-date-picker
                            v-model="beginDate"
                            :prefix-icon="'1'"
                            :editable="false"
                            type="date"
                            value-format="yyyy-MM-dd hh:mm:ss"
                            placeholder="选择日期"
                            :picker-options="pickerOptions"
                          ></el-date-picker>
                        </el-form-item>
                      </span>
                    </span>
                  </p>
                  <p class="travel-attr-btn">
                    <span
                      class="orange-btn"
                      @click="editContinue"
                    >保存收起</span>
                  </p>
                </div>
              </el-form>
              <div
                class="modal-layer"
                v-show="modalVisible"
              >
                <div class="modal-panel">
                  <span
                    class="dash-border-all"
                    v-show="!ruleForm.playDays && !ruleForm.price"
                  >
                    <span>
                      <el-input @focus="
                          modalVisible = false;
                          $refs.playDays.focus();
                        "></el-input>
                    </span>
                    <span>
                      <el-input @focus="
                          modalVisible = false;
                          $refs.price.focus();
                        "></el-input>
                    </span>
                  </span>
                  <span
                    class="dash-border-left"
                    v-show="!ruleForm.playDays && ruleForm.price"
                  >
                    <span>
                      <el-input @focus="
                          modalVisible = false;
                          $refs.playDays.focus();
                        "></el-input>
                    </span>
                  </span>
                  <span
                    class="dash-border-right"
                    v-show="ruleForm.playDays && !ruleForm.price"
                  >
                    <span>
                      <el-input @focus="
                          modalVisible = false;
                          $refs.price.focus();
                        "></el-input>
                    </span>
                  </span>
                  <span
                    class="hint-container"
                    :class="
                      !ruleForm.playDays && !ruleForm.price
                        ? 'position-middle'
                        : !ruleForm.price
                        ? 'position-right'
                        : 'position-left'
                    "
                  >
                    <span class="hint-arrows"></span>
                    <span class="hint-text">填写会更容易被推荐</span>
                  </span>
                </div>
              </div>
            </div>
          </transition>
        </div>
        <template
          v-for="(items, index) in form.nodeList"
          style="position: relative"
        >
          <div class="info-level2">
            <!-- 加号 -->
            <div class="info-timeline-level2">
              <div class="grayline-level2-top"></div>
              <div
                v-if="items.name !== ''"
                class="green-ball ball-level2"
                @click="collapseToggle(items, index)"
                :class="items.collapse ? 'green-ball-outline' : 'green-ball'"
              >
                <i
                  class="icon el-icon-close"
                  :class="items.collapse ? 'rotate45' : ''"
                ></i>
              </div>
              <div class="grayline-level2-bottom"></div>
            </div>
            <div
              class="info-content-level2"
              :ref="'node' + index"
            >
              <div
                class="title-level2"
                v-if="items.name !== ''"
              >
                <p class="monitorTarget">{{ items.name }}</p>
                <p class="icon-bar">
                  <i
                    class="icon el-icon-edit"
                    @click="editDay(items, items.dayName, index)"
                  ></i>
                  <i
                    :class="
                      index === 0
                        ? 'icon-op el-icon-delete'
                        : 'icon el-icon-delete'
                    "
                    @click="removeDay(items, index)"
                  ></i>
                </p>
                <el-dialog
                  :close-on-click-modal="false"
                  title="修改日程"
                  :visible.sync="items.editDayVisible"
                  width="780px"
                  @close="closeDay(items, items.dayName, index)"
                >
                  <el-form
                    :model="items"
                    class="edit_day_form"
                    :ref="`day_edit_form${index}`"
                    :rules="dayRules"
                    @submit.native.prevent
                  >
                    <el-form-item prop="dayName">
                      <el-input
                        class="dialog-input"
                        maxlength="15"
                        v-model="items.dayName"
                        @keyup.enter.native="
                          saveDay(items, index, items.dayName)
                        "
                      ></el-input>
                    </el-form-item>
                    <el-form-item>
                      <el-button
                        class="dialog-save-btn"
                        type="warning"
                        @click="saveDay(items, index, items.dayName)"
                      >保 存</el-button>
                    </el-form-item>
                  </el-form>
                </el-dialog>
              </div>
              <!-- 加号内容 -->
              <div
                v-if="items.name !== ''"
                class="toolbar-level2"
                :class="
                  items.collapse ? 'toolbar-level2-hide' : 'toolbar-level2-show'
                "
              >
                <p class="level2-add">
                  <span @click="addnode(items, index)">
                    <!-- <i class="icon el-icon-location-outline"></i> -->
                    <img src="~@/assets/images/icons/icon-destination.png" />
                    目的地
                  </span>
                </p>
                <!-- v-if="nodeListIndexs.childIndex === j" -->
                <!-- <div v-for="(itemschild, j) in items.paragraphList" :key="j"> -->

                <!-- </div> -->
                <p class="level2-add">
                  <span @click="addtheme(items, index)">
                    <!-- <i class="icon el-icon-location-outline"></i> -->
                    <img src="~@/assets/images/icons/icon-my-experience.png" />
                    经验
                  </span>
                </p>
                <div
                  class="theme"
                  v-for="(itemschild, j) in items.paragraphList"
                  :key="'theme' + j"
                ></div>
                <p class="level2-add">
                  <span @click="addschedule(index)">
                    <!-- <i class="icon el-icon-location-outline"></i> -->
                    <img src="~@/assets/images/icons/icon-my-schedule.png" />
                    日程
                  </span>
                </p>
                <p class="level2-add">
                  <span @click="addtext(index)">
                    <!-- <i class="icon el-icon-location-outline"></i> -->
                    <img src="~@/assets/images/travel/text.png" />
                    文本
                  </span>
                </p>
              </div>
              <!-- 节点 -->
              <template v-for="(itemschild, j) in items.paragraphList">
                <!-- 目的地 -->
                <div
                  class="monitorTarget"
                  v-if="itemschild.type === 1"
                  :ref="'nodechild' + index + j"
                  :key="`${j}itemchild`"
                >
                  <div class="info-content-level3">
                    <div
                      class="toolbar-level3"
                      v-if="itemschild.name !== ''"
                    >
                      <p class="tool-item">
                        <!-- <span class="icon-ball green-ball">
                        <i class="icon el-icon-location-outline"></i>
                        </span>-->
                        <span
                          class="icon-span"
                          :style="{
                            'background-image': `url(${imageMappingDestination()}`
                          }"
                        ></span>
                        {{ itemschild.name }}
                      </p>
                      <p class="tool-item">
                        <span class="plus-icon">
                          <i
                            class="icon el-icon-circle-plus-outline"
                            @click="collapseToggleChild(itemschild, index, j)"
                          ></i>
                        </span>
                        <span :class="
                            itemschild.collapse
                              ? 'toolbar-level3-hide'
                              : 'toolbar-level3-show'
                          ">
                          <span
                            class="plus-icon"
                            @click="addimgfuction(itemschild, index, j)"
                          >
                            <img src="~@/assets/images/icons/image-gray.png" />
                            <small class="icon-text">图片</small>
                          </span>
                          <span
                            class="plus-icon"
                            @click="addvideofuction(itemschild, index, j)"
                          >
                            <!-- <i class="icon el-icon-circle-plus-outline"></i> -->
                            <img src="~@/assets/images/icons/video-gray.png" />
                            <small class="icon-text">视频</small>
                          </span>
                          <span
                            class="plus-icon"
                            @click="addtheme(items, index)"
                          >
                            <!-- <i class="icon el-icon-circle-plus-outline"></i> -->
                            <img src="~@/assets/images/icons/exp-gray.png" />
                            <small class="icon-text">经验</small>
                          </span>
                          <span
                            class="plus-icon"
                            @click="addschedule(index, j)"
                          >
                            <!-- <i class="icon el-icon-circle-plus-outline"></i> -->
                            <img src="~@/assets/images/icons/days-gray.png" />
                            <small class="icon-text">日程</small>
                          </span>
                          <span
                            class="plus-icon"
                            @click="addtext(index, j)"
                          >
                            <!-- <i class="icon el-icon-circle-plus-outline"></i> -->
                            <img src="~@/assets/images/icons/text-gray.png" />
                            <small class="icon-text">文本</small>
                          </span>
                        </span>
                      </p>
                      <p class="tool-item">
                        <i
                          class="icon el-icon-edit"
                          @click="editNode(itemschild, index, j)"
                        ></i>
                        <i
                          class="icon el-icon-delete"
                          @click="deleteNode(itemschild, index, j)"
                        ></i>
                      </p>
                    </div>
                  </div>
                  <!-- 目的地下的图片视频文本 -->
                  <template v-for="(itemschildchild, z) in itemschild.bodyList">
                    <div class="info-content-level3">
                      <div v-if="itemschildchild.type === 1">
                        <div class="content-item">
                          <img
                            v-if="itemschildchild.content"
                            class="image-item"
                            :src="itemschildchild.content"
                          />
                          <img
                            class="remove-icon"
                            @click="
                              deleteImg(itemschildchild, itemschild.bodyList)
                            "
                            src="~@/assets/images/travel/delete.png"
                          />
                          <!-- <i
                            class="el-icon-delete"
                            @click="
                              removeimgs(itemschildchild, itemschild.bodyList)
                            "
                            style="position: absolute; right: 0px;top:31px"
                          ></i>-->
                          <!-- <img src="~@/assets/images/travel/delete.png" /> -->
                        </div>
                      </div>
                      <div v-else-if="itemschildchild.type === 2">
                        <div class="content-item">
                          <video
                            v-if="itemschildchild.content"
                            controls="controls"
                            :ref="`${index}${j}${z}video`"
                            :src="itemschildchild.content"
                          ></video>
                          <img
                            class="remove-icon"
                            @click="
                              deleteVideo(itemschildchild, itemschild.bodyList)
                            "
                            src="~@/assets/images/travel/delete.png"
                          />
                        </div>
                      </div>
                      <div v-else-if="itemschildchild.type === 4">
                        <div class="content-item">
                          <textarea
                            v-if="itemschildchild.type"
                            v-model="itemschildchild.content"
                            :placeholder="randomText(index, j)"
                            cols="30"
                            rows="10"
                          ></textarea>
                          <img
                            class="remove-icon"
                            @click="
                              deleteText(
                                index,
                                j,
                                itemschild,
                                itemschildchild,
                                itemschild.bodyList
                              )
                            "
                            src="~@/assets/images/travel/delete.png"
                          />
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
                <!-- 经验 -->
                <div
                  class="monitorTarget"
                  v-if="itemschild.type === 2"
                  :ref="'nodechild' + index + j"
                  :key="`${j}itemchild`"
                >
                  <div class="info-content-level3">
                    <div
                      class="toolbar-level3"
                      v-if="itemschild.name !== ''"
                    >
                      <p class="tool-item">
                        <!-- <span class="icon-ball green-ball">
                          <i class="icon el-icon-location-outline"></i>
                        </span>-->
                        <span
                          class="icon-span"
                          :style="{
                            'background-image': `url(${imageMapping(
                              itemschild.name
                            )}`
                          }"
                        ></span>
                        {{ itemschild.name }}
                      </p>
                      <p class="tool-item">
                        <span class="plus-icon">
                          <i
                            class="icon el-icon-circle-plus-outline"
                            @click="collapseToggleChild(itemschild, index, j)"
                          ></i>
                        </span>
                        <span :class="
                            itemschild.collapse
                              ? 'toolbar-level3-hide'
                              : 'toolbar-level3-show'
                          ">
                          <span
                            class="plus-icon"
                            @click="addimgfuction(itemschild, index, j)"
                          >
                            <img src="~@/assets/images/icons/image-gray.png" />
                            <small class="icon-text">图片</small>
                          </span>
                          <span
                            class="plus-icon"
                            @click="addvideofuction(itemschild, index, j)"
                          >
                            <!-- <i class="icon el-icon-circle-plus-outline"></i> -->
                            <img src="~@/assets/images/icons/video-gray.png" />
                            <small class="icon-text">视频</small>
                          </span>
                          <span
                            class="plus-icon"
                            @click="addtheme(items, index)"
                          >
                            <!-- <i class="icon el-icon-circle-plus-outline"></i> -->
                            <img src="~@/assets/images/icons/exp-gray.png" />
                            <small class="icon-text">经验</small>
                          </span>
                          <span
                            class="plus-icon"
                            @click="addschedule(index, j)"
                          >
                            <!-- <i class="icon el-icon-circle-plus-outline"></i> -->
                            <img src="~@/assets/images/icons/days-gray.png" />
                            <small class="icon-text">日程</small>
                          </span>
                          <span
                            class="plus-icon"
                            @click="addtext(index, j)"
                          >
                            <!-- <i class="icon el-icon-circle-plus-outline"></i> -->
                            <img src="~@/assets/images/icons/text-gray.png" />
                            <small class="icon-text">文本</small>
                          </span>
                        </span>
                      </p>
                      <p class="tool-item">
                        <i
                          class="icon el-icon-edit"
                          @click="editNode(itemschild, index, j)"
                        ></i>
                        <i
                          class="icon el-icon-delete"
                          @click="deleteNode(itemschild, index, j)"
                        ></i>
                      </p>
                    </div>
                  </div>
                  <!-- 经验下的图片视频文本 -->
                  <template v-for="(itemschildchild, z) in itemschild.bodyList">
                    <div class="info-content-level3">
                      <div v-if="itemschildchild.type === 1">
                        <div class="content-item">
                          <img
                            v-if="itemschildchild.content"
                            class="image-item"
                            :src="itemschildchild.content"
                          />
                          <img
                            class="remove-icon"
                            @click="
                              deleteImg(itemschildchild, itemschild.bodyList)
                            "
                            src="~@/assets/images/travel/delete.png"
                          />
                        </div>
                      </div>
                      <div v-else-if="itemschildchild.type === 2">
                        <div class="content-item">
                          <video
                            v-if="itemschildchild.content"
                            controls="controls"
                            :ref="`${index}${j}${z}video`"
                            :src="itemschildchild.content"
                          ></video>
                          <img
                            class="remove-icon"
                            @click="
                              deleteVideo(itemschildchild, itemschild.bodyList)
                            "
                            src="~@/assets/images/travel/delete.png"
                          />
                        </div>
                      </div>
                      <div v-else-if="itemschildchild.type === 4">
                        <div class="content-item">
                          <textarea
                            v-if="itemschildchild.type"
                            v-model="itemschildchild.content"
                            :placeholder="randomText(index, j)"
                            cols="30"
                            rows="10"
                          ></textarea>
                          <img
                            class="remove-icon"
                            @click="
                              deleteText(
                                index,
                                j,
                                itemschild,
                                itemschildchild,
                                itemschild.bodyList
                              )
                            "
                            src="~@/assets/images/travel/delete.png"
                          />
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
                <!-- 新建数据 -->
                <div
                  class="monitorTarget"
                  v-if="itemschild.type === 3"
                  :ref="'nodechild' + index + j"
                  :key="`${j}itemchild`"
                >
                  <div class="info-content-level3">
                    <div
                      class="toolbar-level3"
                      v-if="itemschild.name !== ''"
                    >
                      <p class="tool-item">
                        <!-- <span class="icon-ball green-ball">
                          <i class="icon el-icon-location-outline"></i>
                        </span>-->
                        <span
                          class="icon-span"
                          :style="{
                            'background-image': `url(${imageMappingDestination()}`
                          }"
                        ></span>
                        <span>{{ itemschild.name }}</span>
                      </p>
                      <p class="tool-item">
                        <span class="plus-icon">
                          <i
                            class="icon el-icon-circle-plus-outline"
                            @click="collapseToggleChild(itemschild, index, j)"
                          ></i>
                        </span>
                        <span :class="
                            itemschild.collapse
                              ? 'toolbar-level3-hide'
                              : 'toolbar-level3-show'
                          ">
                          <span
                            class="plus-icon"
                            @click="addimgfuction(itemschild, index, j)"
                          >
                            <!-- <i class="icon el-icon-circle-plus-outline"></i> -->
                            <img src="~@/assets/images/icons/image-gray.png" />
                            <small class="icon-text">图片</small>
                          </span>
                          <span
                            class="plus-icon"
                            @click="addvideofuction(itemschild, index, j)"
                          >
                            <!-- <i class="icon el-icon-circle-plus-outline"></i> -->
                            <img src="~@/assets/images/icons/video-gray.png" />
                            <small class="icon-text">视频</small>
                          </span>
                          <span
                            class="plus-icon"
                            @click="addtheme(items, index)"
                          >
                            <!-- <i class="icon el-icon-circle-plus-outline"></i> -->
                            <img src="~@/assets/images/icons/exp-gray.png" />
                            <small class="icon-text">经验</small>
                          </span>
                          <span
                            class="plus-icon"
                            @click="addschedule(index, j)"
                          >
                            <!-- <i class="icon el-icon-circle-plus-outline"></i> -->
                            <img src="~@/assets/images/icons/days-gray.png" />
                            <small class="icon-text">日程</small>
                          </span>
                          <span
                            class="plus-icon"
                            @click="addtext(index, j)"
                          >
                            <!-- <i class="icon el-icon-circle-plus-outline"></i> -->
                            <img src="~@/assets/images/icons/text-gray.png" />
                            <small class="icon-text">文本</small>
                          </span>
                        </span>
                      </p>
                      <p class="tool-item">
                        <i
                          class="icon el-icon-edit"
                          @click="editNewNode(itemschild, index, j)"
                        ></i>
                        <i
                          class="icon el-icon-delete"
                          @click="deleteNode(itemschild, index, j)"
                        ></i>
                      </p>
                    </div>
                  </div>
                  <!-- 经验下的图片视频文本 -->
                  <template v-for="(itemschildchild, z) in itemschild.bodyList">
                    <div class="info-content-level3">
                      <div v-if="itemschildchild.type === 1">
                        <div class="content-item">
                          <img
                            v-if="itemschildchild.content"
                            class="image-item"
                            :src="itemschildchild.content"
                          />
                          <img
                            class="remove-icon"
                            @click="
                              deleteImg(itemschildchild, itemschild.bodyList)
                            "
                            src="~@/assets/images/travel/delete.png"
                          />
                        </div>
                      </div>
                      <div v-else-if="itemschildchild.type === 2">
                        <div class="content-item">
                          <video
                            v-if="itemschildchild.content"
                            controls="controls"
                            :ref="`${index}${j}${z}video`"
                            :src="itemschildchild.content"
                          ></video>
                          <img
                            class="remove-icon"
                            @click="
                              deleteVideo(itemschildchild, itemschild.bodyList)
                            "
                            src="~@/assets/images/travel/delete.png"
                          />
                        </div>
                      </div>
                      <div v-else-if="itemschildchild.type === 4">
                        <div class="content-item">
                          <textarea
                            v-if="itemschildchild.type"
                            v-model="itemschildchild.content"
                            :placeholder="randomText(index, j)"
                            cols="30"
                            rows="10"
                          ></textarea>
                          <img
                            class="remove-icon"
                            @click="
                              deleteText(
                                index,
                                j,
                                itemschild,
                                itemschildchild,
                                itemschild.bodyList
                              )
                            "
                            src="~@/assets/images/travel/delete.png"
                          />
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
                <!-- 某个日程下面直接的一段文本 -->
                <!-- 修改内容：原来的判断条件是!itemschild.type 现在改为itemschild === 0 
                     修改原因:后台大数据分析在type为空的情况下影响分析
                     外部依赖:后台数据库需要将type设置为0
                     修改时间:2020/2/24
                     修改人:杜鹏
                 -->
                <!-- 修改内容:增加图片类型、视频类型
                     修改原因:为了适用于图文混排后图片和视频没有类型
                     修改时间:2020/3/11
                     修改人:杜鹏
                 -->
                <div
                  v-if="itemschild.type === 0"
                  :key="`${j}itemchild`"
                >
                  <template v-for="(itemschildchild, z) in itemschild.bodyList">
                    <div class="info-content-level3">
                      <div v-if="itemschildchild.type === 4">
                        <div class="content-item">
                          <textarea
                            v-if="itemschildchild.type"
                            v-model="itemschildchild.content"
                            :placeholder="randomText(index, j)"
                            cols="30"
                            rows="10"
                          ></textarea>
                          <img
                            class="remove-icon"
                            @click="
                              deleteText(
                                index,
                                j,
                                itemschild,
                                itemschildchild,
                                itemschild.bodyList
                              )
                            "
                            src="~@/assets/images/travel/delete.png"
                          />
                        </div>
                      </div>
                      <div v-else-if="itemschildchild.type === 1">
                        <div class="content-item">
                          <img
                            v-if="itemschildchild.content"
                            class="image-item"
                            :src="itemschildchild.content"
                          />
                          <img
                            class="remove-icon"
                            @click="
                              deleteImg(itemschildchild, itemschild.bodyList)
                            "
                            src="~@/assets/images/travel/delete.png"
                          />
                        </div>
                      </div>
                      <div v-else-if="itemschildchild.type === 2">
                        <div class="content-item">
                          <video
                            v-if="itemschildchild.content"
                            controls="controls"
                            :ref="`${index}${j}${z}video`"
                            :src="itemschildchild.content"
                          ></video>
                          <img
                            class="remove-icon"
                            @click="
                              deleteVideo(itemschildchild, itemschild.bodyList)
                            "
                            src="~@/assets/images/travel/delete.png"
                          />
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </template>
            </div>
          </div>
        </template>
      </div>
      <!-- 添加目的地共通dialog -->
      <el-dialog
        :close-on-click-modal="false"
        :title="currentDestinationDialog.title"
        v-if="currentDestinationDialog.itemschild.DestinationVisible"
        :visible.sync="currentDestinationDialog.itemschild.DestinationVisible"
        @close="
          closeNode(
            currentDestinationDialog.itemschild,
            currentDestinationDialog.index,
            currentDestinationDialog.j
          )
        "
        width="780px"
      >
        <el-form
          class="add_destination_form"
          :model="currentDestinationDialog.itemschild"
          :ref="`destination${currentDestinationDialog.index}`"
          :rules="destinationRules"
          @submit.native.prevent
          @keyup.enter.native="
            currentDestinationDialog.itemschild.List[0].label === '无数据'
              ? dialognewNode(
                  currentDestinationDialog.itemschild,
                  currentDestinationDialog.index,
                  currentDestinationDialog.j
                )
              : dialogaddNode(
                  currentDestinationDialog.itemschild,
                  currentDestinationDialog.index,
                  currentDestinationDialog.j
                )
          "
        >
          <el-form-item prop="name">
            <el-autocomplete
              :trigger-on-focus="triggerFocus"
              class="dialog-input"
              v-model="currentDestinationDialog.itemschild.name"
              :ref="`tags${currentDestinationDialog.j}`"
              :fetch-suggestions="remoteMethod"
              placeholder="请输入内容"
              @select="nameChange"
              @focus="
                selectChange(
                  $event,
                  currentDestinationDialog.index,
                  currentDestinationDialog.j
                )
              "
            ></el-autocomplete>
          </el-form-item>
          <el-form-item>
            <el-button
              type="warning"
              class="dialog-save-btn"
              @click="
                currentDestinationDialog.itemschild.List[0].label === '无数据'
                  ? dialognewNode(
                      currentDestinationDialog.itemschild,
                      currentDestinationDialog.index,
                      currentDestinationDialog.j
                    )
                  : dialogaddNode(
                      currentDestinationDialog.itemschild,
                      currentDestinationDialog.index,
                      currentDestinationDialog.j
                    )
              "
            >确 定</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <!-- 添加经验共通dialog -->
      <el-dialog
        :close-on-click-modal="false"
        :title="currentExperienceDialog.title"
        :visible.sync="currentExperienceDialog.itemschild.ThemeVisible"
        @close="
          closeNode(
            currentExperienceDialog.itemschild,
            currentExperienceDialog.index,
            currentExperienceDialog.j
          )
        "
        width="780px"
      >
        <el-form
          :model="currentExperienceDialog.itemschild"
          :ref="`experience${currentExperienceDialog.index}`"
          :rules="experienceRules"
          @submit.native.prevent
        >
          <el-form-item prop="name">
            <el-input
              v-model="currentExperienceDialog.itemschild.name"
              maxlength="15"
              @keyup.enter.native="
                dialogaddNode(
                  currentExperienceDialog.itemschild,
                  currentExperienceDialog.index,
                  currentExperienceDialog.j
                )
              "
            ></el-input>
          </el-form-item>
        </el-form>
        <p class="check-bar">
          <template v-for="(item, k) in list">
            <span
              :class="k"
              :key="k"
              @click="
                quickThemeCheck(
                  currentExperienceDialog.itemschild,
                  currentExperienceDialog.index,
                  currentExperienceDialog.j,
                  k
                )
              "
            >{{ item }}</span>
          </template>
        </p>
        <span slot="footer">
          <el-button
            type="warning"
            class="dialog-save-btn"
            @click="
              dialogaddNode(
                currentExperienceDialog.itemschild,
                currentExperienceDialog.index,
                currentExperienceDialog.j
              )
            "
          >保 存</el-button>
        </span>
      </el-dialog>
      <!-- 上传图片共通dialog -->
      <el-dialog
        :close-on-click-modal="false"
        title="上传图片"
        @close="
          closeImg(
            currentImageDialog.itemschildchild,
            currentImageDialog.index,
            currentImageDialog.j,
            currentImageDialog.z
          )
        "
        :visible.sync="currentImageDialog.itemschildchild.imgVisible"
        width="780px"
      >
        <el-upload
          ref="mutiUpload"
          class="img-multi-upload"
          :class="showInsertImgButton === false ? 'hide-insert-button' : ''"
          :action="action"
          list-type="picture-card"
          :multiple="true"
          :limit="5"
          :data="data"
          :auto-upload="autoUploadMulti"
          :on-change="handleChangeMulti"
          :on-success="handleSuccessMulti"
          :on-progress="handleProgressMulti"
          :on-error="handleErrorMulti"
          :before-upload="beforeUploadMulti"
          :on-exceed="handleExceed"
          :show-file-list="true"
          :file-list="fileListMulti"
          :accept="'.jpeg,.png,.jpg'"
        >
          <div
            slot="default"
            class="upload-img-bg"
            @click="selectLoaclFile()"
          >
            <common-icon
              class="add-img-icon"
              :iconId="'#icontianjiatupian'"
            ></common-icon>
          </div>
          <div
            class="img-container"
            slot="file"
            slot-scope="{ file }"
          >
            <img
              class="el-upload-list__item-thumbnail"
              :src="file.url"
              alt=""
            />
            <span class="el-upload-del-container">
              <!-- 删除图片icon -->
              <common-icon
                @delFun="delUploadImg(file)"
                :deleteFlag="true"
                class="delete-img-icon"
                :iconId="'#iconshanchutupian'"
              ></common-icon>
            </span>
            <span
              class="el-upload-list__item-custom-actions"
              :class="file.status === 'uploading' ? 'upload-img-cover' : ''"
            >
              <!-- 上传中的图片 -->
              <span v-if="file.status === 'uploading'">
                <common-icon
                  class="rotate_360"
                  :iconId="'#iconshangchuantupian-jiazai'"
                ></common-icon>
              </span>
              <!-- 上传失败需要重新上传的图片 -->
              <span v-if="file.status === 'fail'">
                <common-icon
                  class="reupload-img-icon"
                  :reUploadFlag="true"
                  @reUploadFun="reUploadImg(file)"
                  :iconId="'#iconzhongxinshangchuan'"
                ></common-icon>
              </span>
              <!-- 上传成功的图片 -->
              <span v-if="file.status === 'success'">
                <common-icon :iconId="'#iconshangchuanchenggong'"></common-icon>
              </span>
            </span>
          </div>
        </el-upload>
        <div slot="footer">
          <p class="remind-text">
            支持同时上传5张JPG、JPEG、PNG格式，小于5M的图片
          </p>
          <el-button
            :disabled="disableInsertMultiImgs"
            type="warning"
            class="dialog-upload-btn"
            @click="
              addMuitiImgs(
                currentImageDialog.index,
                currentImageDialog.j,
                currentImageDialog.z
              )
            "
          >确认</el-button>
        </div>
      </el-dialog>
      <!-- 上传视频共通dialog -->
      <el-dialog
        :close-on-click-modal="false"
        title="上传视频"
        :visible.sync="currentVideoDialog.itemschildchild.videoVisible"
        @close="
          closeImg(
            currentVideoDialog.itemschildchild,
            currentVideoDialog.index,
            currentVideoDialog.j,
            currentVideoDialog.z
          )
        "
        width="780px"
      >
        <el-upload
          :action="action"
          :data="data"
          :on-progress="uploadVideoProcess"
          :on-success="handleSuccess"
          :on-error="hideProcess"
          :before-upload="beforeUpload"
          :show-file-list="false"
          :file-list="currentVideoDialog.itemschild.videoList"
          v-show="currentDialogContent.button"
          :accept="'.mp4'"
        >
          <el-button
            v-if="!currentVideoDialog.itemschildchild.content"
            type="warning"
            class="dialog-upload-btn"
            @click="
              addimgs(
                currentVideoDialog.index,
                currentVideoDialog.j,
                currentVideoDialog.z,
                2
              )
            "
          >上传本地视频</el-button>
        </el-upload>
        <p
          class="remind-text"
          v-show="currentDialogContent.button"
        >
          视频大小不得超过25M，时长不得大于30s
        </p>
        <upload-process v-show="currentDialogContent.loading" />
        <!-- <i
            v-if="!itemschildchild.content"
            @click="addimgs(index, j, z, 2)"
            class="el-icon-plus avatar-uploader-icon"
        >视频</i>-->
        <!-- <el-progress
            v-if="videoFlag == true && !itemschildchild.content"
            type="circle"
            v-bind:percentage="videoUploadPercent"
            style="margin-top:7px;"
        ></el-progress>-->
        <!-- </el-upload> -->
      </el-dialog>
      <!-- 目录导航内容 -->
      <div
        class="travel-navi"
        :style="tNaviStyle"
        ref="tNavi"
      >
        <div class="navi-title">
          <p>目录导航</p>
          <div
            class="sort-button"
            @click="showTxtGraphics"
          >
            <common-icon
              class="drag-item-entrance"
              :iconId="'#iconpaixu'"
            ></common-icon>
            <span>排序</span>
          </div>
        </div>
        <div class="navi-content">
          <div class="gray-bar"></div>
          <div class="navi-content-area">
            <template v-for="(items, index) in form.nodeList">
              <div
                class="navi-item naviTarget"
                :key="`navi-${index}`"
                v-if="items.name !== ''"
                :ref="`navi${index}`"
              >
                <p class="left-line">
                  <span class="thin-line line-top"></span>
                  <span
                    class="small-point"
                    :class="naviChecked == index ? 'checked-ball' : ''"
                  ></span>
                  <span class="thin-line line-bottom"></span>
                </p>
                <p
                  class="item-text level2-navi-item"
                  :class="naviChecked == index ? 'checked-text' : ''"
                  @click="nodeClick($event, items, index)"
                >
                  {{ items.name }}
                </p>
              </div>
              <template v-for="(itemschild, j) in items.paragraphList">
                <div
                  class="navi-item naviTarget"
                  v-if="itemschild.name !== ''"
                  :key="`navi-line-${index}-${j}`"
                  :ref="`navi${index}${j}`"
                >
                  <p class="left-line">
                    <span class="thin-line line-top"></span>
                    <span
                      class="small-point"
                      :class="
                        naviChildChecked == `${index}${j}` ? 'checked-ball' : ''
                      "
                    ></span>
                    <span class="thin-line line-bottom"></span>
                  </p>
                  <p
                    class="item-text  level3-navi-item"
                    :class="
                      naviChildChecked == `${index}${j}` ? 'checked-text' : ''
                    "
                    @click="nodechildClick($event, index, j)"
                  >
                    {{ itemschild.name }}
                  </p>
                </div>
              </template>
            </template>
          </div>
        </div>
        <div class="navi-footer">
          <div
            class="navi-btn review"
            @click="Preview"
          >预览</div>
          <div
            class="navi-btn release"
            @click="Release"
          >发布</div>
        </div>
      </div>
    </div>
    <el-dialog
      class="txt-graphics-style"
      title="拖拽调整游记内图片文本顺序"
      :visible.sync="txtGraphicsVisible"
      :show-close="false"
      :close-on-click-modal="false"
    >
      <draggable
        class="drag-wrapper"
        v-model="comprehensiveDragList"
      >
        <div
          class="drag-container"
          v-for="(comprehensiveItem, index) in comprehensiveDragList"
          :key="`${index}comprehensive`"
        >
          <!-- 日程 -->
          <el-popover
            placement="bottom"
            width="200"
            trigger="hover"
            :content="comprehensiveItem.detailedInfo"
            v-if="comprehensiveItem.comprehensiveType === 1"
          >
            <div
              slot="reference"
              class="drag-item-common"
            >
              <span class="drag-item-schedule">{{
                comprehensiveItem.briefInfo
              }}</span>
            </div>
          </el-popover>
          <!-- 目的地 -->
          <el-popover
            v-if="
              comprehensiveItem.comprehensiveType === 2 ||
                comprehensiveItem.comprehensiveType === 3
            "
            placement="bottom"
            width="200"
            trigger="hover"
            :content="comprehensiveItem.detailedInfo"
          >
            <div
              slot="reference"
              class="drag-item-common"
            >
              <common-icon
                class="drag-item-destination"
                :iconId="'#iconbianjiqi-jingdian'"
              ></common-icon>
            </div>
          </el-popover>
          <!-- 经验 -->
          <el-popover
            v-if="comprehensiveItem.comprehensiveType === 4"
            placement="bottom"
            width="200"
            trigger="hover"
            :content="comprehensiveItem.detailedInfo"
          >
            <div
              slot="reference"
              class="drag-item-common"
            >
              <common-icon
                class="drag-item-expericence"
                :iconId="'#iconbianjiqi-jingyan'"
              ></common-icon>
            </div>
          </el-popover>
          <!-- 图片 -->
          <div
            class="drag-item-common"
            v-if="comprehensiveItem.comprehensiveType === 5"
          >
            <div
              class="drag-item-image"
              :style="{
                'background-image': `url(${comprehensiveItem.detailedInfo})`
              }"
            ></div>
          </div>
          <!-- 视频 -->
          <div
            class="drag-item-common drag-video-container"
            v-if="comprehensiveItem.comprehensiveType === 6"
          >
            <video
              class="drag-item-video"
              :src="comprehensiveItem.detailedInfo"
            ></video>
            <common-icon
              class="drag-item-video-icon"
              :iconId="'#iconpiliangshangchuan-zanting'"
            ></common-icon>
          </div>
          <!-- 文本 -->
          <el-popover
            v-if="comprehensiveItem.comprehensiveType === 7"
            placement="bottom"
            width="200"
            trigger="hover"
            :content="comprehensiveItem.detailedInfo"
          >
            <div
              slot="reference"
              class="drag-item-common"
            >
              <common-icon
                class="drag-item-text"
                :iconId="'#iconbianjiqi-wenzi'"
              ></common-icon>
            </div>
          </el-popover>
        </div>
      </draggable>
      <span slot="footer">
        <el-button
          @click="cancleGraphicMixed"
          type="info"
        >取消</el-button>
        <el-button
          @click="sureGraphicMixed"
          type="warning"
        >确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import api from "../../axios/api";
import draggable from "vuedraggable";
import { mapState, mapActions, mapMutations } from "vuex";
import Global from "../../utils/Global";
import service from "../../axios/service/service";
import uploadProcess from "@/components/kits/uploadProcess";
import imgUrlToIdMixin from "@/mixins/imgUrlToId.js";
import { Loading } from "element-ui";
import { VueCropper } from "vue-cropper";
//引入上传裁剪后的图片专用的ajax方法(从el-upload里面搬来的做个微小改动)
import uploadFileAjax from "@/utils/uploadFileAjax.js";
//引入彩色icon组件
import CommonIcon from "@/components/icon/CommonIcon";
import uploadUtils from "@/utils/uploadUtils";
export default {
  name: "write",
  mixins: [imgUrlToIdMixin],
  components: {
    draggable,
    uploadProcess,
    VueCropper,
    CommonIcon
  },
  watch: {
    "currentDestinationDialog.itemschild.name": {
      deep: true,
      handler: function(newV, oldV) {
        this.oldDestination = oldV;
      }
    },
    searchName: function(value) {
      this.searchValueMutations(value);
    },
    findtreveldetail: function(value) {
      this.form = value[0];
      this.deleteFlag(this.form);
      this.visibleFlag(this.form);
      this.collapse(this.form);
      //游记属性部分的赋值
      this.ruleForm.price = this.form.price;
      this.ruleForm.playDays = this.form.playDays;
      this.beginDate = this.form.beginDate;
      this.tourPar = this.form.tourPar;
      this.difficulty = this.form.difficulty;
      this.ruleForm.totalMileage = this.form.totalMileage;
      this.playTypeIdList = this.form.playTypeIdList
        ? this.form.playTypeIdList
        : [];
    },
    //ruleForm的这三个是游记属性编辑页迁移过来的
    "ruleForm.playDays"(newValue, oldVlue) {
      this.playDaysOldValue = oldVlue;
    },
    "ruleForm.totalMileage"(newValue, oldVlue) {
      this.totalMileageOldValue = oldVlue;
    },
    "ruleForm.price"(newValue, oldVlue) {
      this.priceOldValue = oldVlue;
    }
  },
  data() {
    //这些声明的函数是从
    let playDaysValidate = (rule, value, callback) => {
      let reg = /^([1-9][0-9]*$)/;
      //由于在气泡处校验了，则此处为空就让其校验通过
      if (value === "") {
        callback();
      } else {
        if (!reg.test(value)) {
          this.ruleForm.playDays = this.playDaysOldValue;
          callback();
        }
      }
    };
    // 勿删，改版的时候会用
    let totalMileageValidate = (rule, value, callback) => {
      //整数或者小数点保留后一位
      let reg = /^(\d+)(\.?\d{0,1})?$/;
      if (value === "") {
        callback();
      } else {
        if (!reg.test(value)) {
          this.ruleForm.totalMileage = this.totalMileageOldValue;
          callback();
        }
      }
    };
    // 勿删，改版的时候会用
    let totalMileageValidateEnd = (rule, value, callback) => {
      //如果以"."结尾则删除点
      if (value.indexOf(".") === value.length - 1) {
        this.ruleForm.totalMileage = value.slice(0, value.length - 1);
        callback();
      }
    };
    let totalMileageValidateInt = (rule, value, callback) => {
      let reg = /^([1-9][0-9]*$)/;
      //由于在气泡处校验了，则此处为空就让其校验通过
      if (value === "") {
        callback();
      } else {
        if (!reg.test(value)) {
          this.ruleForm.totalMileage = this.totalMileageOldValue;
          callback();
        }
      }
    };
    let priceValidate = (rule, value, callback) => {
      let reg = /^([1-9][0-9]*$)/;
      //由于在气泡处校验了，则此处为空就让其校验通过
      if (value === "") {
        callback();
      } else {
        if (!reg.test(value)) {
          this.ruleForm.price = this.priceOldValue;
          callback();
        }
      }
    };
    return {
      fileBasePath: "", //文件上传成功后的地址
      fileDirPath: `/frontEnd/travelNote/write/${new Date().getTime()}`,
      txtGraphicsVisible: false, //初始时不显示图文混排弹窗
      oldDestination: "",
      originalUrl: "", //上传封面后原始图片的地址
      downloadUrl: "", //裁剪封面图片成功后图片的下载地址
      showAttributeEdit: false, //是否展开属性编辑弹窗
      /*********************************************************************************/
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      priceOldValue: "",
      playDaysOldValue: "",
      totalMileageOldValue: "",
      partnerList: [
        { code: 1, label: "独自一人" },
        { code: 2, label: "好友" },
        { code: 3, label: "亲子" },
        { code: 4, label: "情侣" },
        { code: 5, label: "闺蜜" },
        { code: 6, label: "同学" },
        { code: 7, label: "拼团" },
        { code: 8, label: "家人" }
      ],
      difficultList: [
        { code: 1, label: "轻松" },
        { code: 2, label: "适中" },
        { code: 3, label: "困难" }
      ],
      modalVisible: false,
      playTypeIdList: [],
      playWaydata: "",
      tourPar: "",
      difficulty: "",
      beginDate: "",
      ruleForm: {
        playDays: "",
        price: "",
        totalMileage: ""
      },
      rules: {
        playDays: [{ validator: playDaysValidate, trigger: "change" }],
        price: [{ validator: priceValidate, trigger: "change" }],
        totalMileage: [
          { validator: totalMileageValidateInt, trigger: "change" }
          /* { validator: totalMileageValidate, trigger: "change" },
          { validator: totalMileageValidateEnd, trigger: "blur" } */
        ]
      },
      /*********************************************************************************/
      showCropper: false, //是否显示裁剪组件
      loadingInstance: "", //遮罩层（loading）实例
      option: {
        img: "", //裁剪图片的地址
        size: 1,
        outputType: "jpeg", // 裁剪生成图片的格式
        info: true, //裁剪框的大小信息
        full: false, // 是否输出原图比例的截图
        canMove: true, //上传图片是否可以移动,
        canMoveBox: true, //截图框能否拖动
        autoCrop: true, //是否默认生成截图框
        autoCropWidth: 960, //默认生成截图框宽度 (单位px)
        autoCropHeight: 330, //默认生成截图框高度 (单位px)
        fixed: true, //是否开启截图框宽高固定比例
        fixedNumber: [32, 11] //截图框的宽高比例 [宽度，高度]
      },
      triggerFocus: false,
      //当前视频弹窗对象
      currentVideoDialog: {
        itemschildchild: {},
        index: "",
        j: "",
        z: "",
        itemschild: {}
      },
      //当前图片弹窗对象
      currentImageDialog: {
        itemschildchild: {},
        index: "",
        j: "",
        z: "",
        itemschild: {}
      },
      //当前经验弹窗对象
      currentExperienceDialog: {
        title: "",
        itemschild: {},
        index: "",
        j: ""
      },
      //当前目的地弹窗对象
      currentDestinationDialog: {
        title: "",
        itemschild: {},
        index: "",
        j: ""
      },
      noTitle: false, //刚进页面，不做必填项检查所以设置为false
      naviChecked: "", //判断目录是否被选中使用
      naviChildChecked: "", //判断目录是否被选中使用
      destinationRules: {
        name: [{ required: true, message: "输入内容不能为空", trigger: "blur" }]
      },
      experienceRules: {
        name: [{ required: true, message: "输入内容不能为空", trigger: "blur" }]
      },
      dayRules: {
        dayName: [
          { required: true, message: "输入内容不能为空", trigger: "blur" }
        ]
      },
      hasUploadCover: false, //是否上传过封面
      coverHintNotUpload: "点击上传封面图片", //上传封面的提示文字
      coverHintHasUpload: "点击修改封面图片", //上传封面的提示文字
      childrenList: [],
      list: [
        "穿衣指南",
        "注意事项",
        "温馨提示",
        "避坑秘籍",
        "民族风俗",
        "禁忌",
        "必备物品",
        "剁手清单",
        "交通",
        "美食推荐",
        "节日",
        "不能错过"
      ],
      imageOfType: {
        穿衣指南: require("@/assets/images/icons/type/dressing.png"),
        注意事项: require("@/assets/images/icons/type/attention.png"),
        温馨提示: require("@/assets/images/icons/type/hint.png"),
        避坑秘籍: require("@/assets/images/icons/type/cheats.png"),
        民族风俗: require("@/assets/images/icons/type/custom.png"),
        禁忌: require("@/assets/images/icons/type/taboo.png"),
        必备物品: require("@/assets/images/icons/type/must.png"),
        剁手清单: require("@/assets/images/icons/type/listing.png"),
        交通: require("@/assets/images/icons/type/traffic.png"),
        美食推荐: require("@/assets/images/icons/type/cate.png"),
        节日: require("@/assets/images/icons/type/festival.png"),
        不能错过: require("@/assets/images/icons/type/cannotmiss.png")
      },
      // 文本的删除样式
      deleteImgDisplay: {
        position: "absolute",
        right: "1px",
        top: "20px",
        display: "block",
        width: "38px",
        height: "38px"
      },
      //图片/视频的删除样式
      deleteImgorVideoDisplay: {
        position: "absolute",
        right: "1px",
        top: "22px",
        display: "block",
        width: "38px",
        height: "38px"
      },
      deleteImgNoDisplay: {
        position: "absolute",
        right: "695px",
        display: "none"
      },
      pageflag: "",
      state: "",
      tNaviStyle: {},
      imageUrl: "",
      // collapse: false,
      data: {},
      action: "",
      dayFlag: "",
      flag: "",
      videoFlag: false,
      visibleflag: 0,
      fileList: [],
      dataone: {},
      datatwo: {},
      datathree: {},
      bodyoneList: [],
      bodytwoList: [],
      bodythreeList: [],
      // editDayVisible: false,
      DestinationVisible: false,
      ThemeVisible: false,
      imgVisible: false,
      currentDialogContent: {
        loading: false,
        button: true,
        remind: false
      },
      form: {
        name: "",
        imgs: "",
        imgsCut: "", //裁切后的图片
        nodeList: [
          {
            name: "前言",
            dayName: "前言",
            nameType: 1, //1、Day日程类型2、说明类型 修改原因：后台要求增加此字段
            paragraphList: [
              {
                fileList: [],
                bodyList: [
                  {
                    type: 4,
                    display: {
                      position: "absolute",
                      right: "695px",
                      display: "none"
                    }
                  }
                ], //节点
                dataId: "", //实体id
                dataTypeId: "", //实体类型
                name: "", //1.地点2.攻略
                type: 0, //1.地点2.攻略 0:直接隶属于某一日程下面的文本
                typecopy: 0,
                videoList: [],
                List: []
              }
            ],
            labelname: "前言",
            editDayVisible: false,
            collapse: true
          },
          {
            name: "第1天",
            dayName: "第1天",
            nameType: 1,
            paragraphList: [],
            labelname: "日程",
            editDayVisible: false,
            collapse: true
          }
        ]
      },
      nodeListIndexs: {
        index: 0,
        childIndex: 0,
        childchildIndex: 0
      },
      text: 0,
      imageLoading: {},
      currentMultiFileList: [],
      fileListMulti: [],
      autoUploadMulti: true,
      disableInsertMultiImgs: true,
      showInsertImgButton: true,
      comprehensiveDragList: [] //拖拽的List
    };
  },
  computed: {
    ...mapState("WriteDataStore", ["playWayList"]), //自驾玩法
    ...mapState("WriteDataStore", ["backData", "writeData"]),
    ...mapState("NewTravelStore", ["findtreveldetail"])
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleTrack() {
      for (let i = 0; i < this.form.nodeList.length; i++) {
        this.form.nodeList[i].track = "";
        if (this.form.nodeList[i].paragraphList) {
          for (let j = 0; j < this.form.nodeList[i].paragraphList.length; j++) {
            if (this.form.nodeList[i].paragraphList[j].type === 1) {
              this.form.nodeList[i].track =
                this.form.nodeList[i].track +
                this.form.nodeList[i].paragraphList[j].lon.toString() +
                "," +
                this.form.nodeList[i].paragraphList[j].lat.toString() +
                ";";
            } else {
              continue;
            }
          }
        }
      }
      for (let k = 0; k < this.form.nodeList.length; k++) {
        this.form.nodeList[k].track = this.form.nodeList[k].track.slice(0, -1);
      }
    },
    //自定义findLastIndex 从后往前找某一元素最后出现的位置
    findLastIndex(findArr, findFunc) {
      let reversedArr = [];
      findArr.forEach(value => reversedArr.push(value));
      for (let i = 0; i < reversedArr.length / 2; i++) {
        let temp = findArr[i];
        reversedArr[i] = reversedArr[reversedArr.length - 1 - i];
        reversedArr[reversedArr.length - 1 - i] = temp;
      }
      let res = reversedArr.findIndex(findFunc);
      if (res === -1) {
        return -1;
      } else {
        return findArr.length - 1 - res;
      }
    },
    //确定图文混排
    sureGraphicMixed() {
      this.txtGraphicsVisible = false;
      /** 图文混排part1 按层级1分组和重组的过程 **/
      //例如原始顺序为： 1 2 3 3 1 2 3 3 3 1 2 3
      //排序后的顺序为： 3 1 2 3 2 1 3 3 3 1 3 2
      //part1最终目标为: [[3],[1,3,3,2],[1,3,3,3],[1,3,2]]
      //排序后的顺序为： 1 2 3 3 1 2 3 3 3 1 2 3
      //part1最终目标为: [[1,2,3,3],[1,2,3,3],[1,2,3]]
      //这就涉及把1单独拿出来和前后的不含1的连续子数组组合的过程，具体做法如下：
      //按照第一层级分组的数组
      let level1Group = [];
      //Step1:查询第一个1所在的位置
      let targetIndex = this.comprehensiveDragList.findIndex(dragItem => {
        return dragItem.levelInfo === 1;
      });
      let oneAtFirst = targetIndex === 0;
      while (targetIndex !== -1) {
        //Step2:查询到1则判断1所在的位置
        //Step2.1:如果位置不等于0,说明不是以1开头，把从数组开头到下一个1之前的数组元素作为一个整体收集起来，并从List中删除
        //Step2.2:如果是以1开头,则这个1作为单独的一组收集起来,并从元素组中删除
        //Step2.3:更新1所在的位置并重复此判断过程
        if (targetIndex !== 0) {
          level1Group.push(this.comprehensiveDragList.slice(0, targetIndex));
          this.comprehensiveDragList.splice(0, targetIndex);
        } else {
          let headArray = this.comprehensiveDragList.splice(0, 1);
          level1Group.push(headArray);
        }
        targetIndex = this.comprehensiveDragList.findIndex(dragItem => {
          return dragItem.levelInfo === 1;
        });
      }
      //Step3:处理数组最后剩余的部分
      level1Group.push(this.comprehensiveDragList);
      //Step4:将含有1的子数组和不含1的子数组组合
      //（1）:加上是否含有1的标识
      //（2）:将分组组合的过程
      let level1GroupToAdjust = [];
      level1Group.forEach(levelGroupItem => {
        let hasLevelOne = levelGroupItem.some(
          groupValue => groupValue.levelInfo === 1
        );
        let groupItem = {
          hasLevelOne, //当前子数组是否含有1
          levelGroupItem //当前子数组
        };
        level1GroupToAdjust.push(groupItem);
      });
      let level1GroupAdjusted = [];
      let adjustIndexBefore = 0;
      let adjustIndexAfter = 1;
      // true 开头 true false true true false
      // true 开头 true true true false true
      // 注意：按照之前按1分组不可能出现两个连续的false
      const level1Adjust = () => {
        while (adjustIndexAfter <= level1GroupToAdjust.length - 1) {
          //尾指针没有到最后，并且所指向元素的hasLevelOne是false
          if (!level1GroupToAdjust[adjustIndexAfter].hasLevelOne) {
            //则将before和after的元素合并
            level1GroupAdjusted.push([
              ...level1GroupToAdjust[adjustIndexBefore].levelGroupItem, //含1的,hasLevelOne是true
              ...level1GroupToAdjust[adjustIndexAfter].levelGroupItem //不含1的,hasLevelOne是false
            ]);
            adjustIndexBefore += 2;
            adjustIndexAfter += 2;
          } else {
            //尾指针没有走到最后，并且所指向元素的hasLevelOne是true (连续两个true的情况)
            //把前一个true放进数组，并更新指针
            level1GroupAdjusted.push(
              level1GroupToAdjust[adjustIndexBefore].levelGroupItem
            );
            adjustIndexBefore += 1;
            adjustIndexAfter += 1;
          }
        }
        //尾指针超出了数组的长度，判断头指针是否超出数组长度，如果没有则直接将头指针放入
        if (adjustIndexBefore <= level1GroupToAdjust.length - 1) {
          level1GroupAdjusted.push(
            level1GroupToAdjust[adjustIndexBefore].levelGroupItem
          );
        }
      };
      //如果true开头
      if (oneAtFirst) {
        level1Adjust();
      } else {
        //如果不是true开头，则删掉这个false并组装后放到目标数组里，剩下的按true处理即可
        let tempDeleated = level1GroupToAdjust.splice(0, 1); //删除第一个false元素
        level1Adjust();
        level1GroupAdjusted.unshift([
          {
            comprehensiveType: 1,
            briefInfo: "",
            detailedInfo: "",
            levelInfo: 1
          },
          ...tempDeleated[0].levelGroupItem
        ]);
      }
      let level1GroupAdded = [];
      /** 图文混排part2: 在1和3之间补充2(补充一个空经验) **/
      level1GroupAdjusted.forEach(adjustedItem => {
        if (adjustedItem.length > 1 && adjustedItem[1].levelInfo === 3) {
          let newExperience = {};
          this.$set(newExperience, "comprehensiveType", 8); //8为空经验类型
          this.$set(newExperience, "briefInfo", "");
          this.$set(newExperience, "detailedInfo", "");
          this.$set(newExperience, "levelInfo", 2);
          adjustedItem.splice(1, 0, newExperience);
        }
        level1GroupAdded.push(adjustedItem);
      });
      // /**图文混排part3: 生成nodeList的节点结构 */
      // //按照是否含有3进行分类，可分为如下几类：
      // //(1)含有3 ：(1.1)以3结尾 如123233 (1.2)以2结尾 如123232222
      // //(2)不含有3： (2.1)含2 如122222 (2.2)不含2只有1 如1
      let containThreeOrNot = [];
      //数据预处理
      level1GroupAdded.forEach(reproduceItem => {
        //是否含有3的判断
        let hasThree = false;
        hasThree = reproduceItem.some(reproduceCheckItem => {
          return reproduceCheckItem.levelInfo === 3;
        });
        //不含3判断是否含有2
        let hasTwo = true;
        if (!hasThree) {
          //含有3肯定含有2，所以只有在不含3的情况下才会出现不含2
          hasTwo = reproduceItem.some(reproduceCheckItem => {
            return reproduceCheckItem.levelInfo === 2;
          });
        }
        containThreeOrNot.push({
          hasThree,
          hasTwo,
          reproduceItem
        });
      });
      //数据处理
      let dragNodeList = [];
      containThreeOrNot.forEach(containItem => {
        if (containItem.hasThree) {
          const formTheNodeList = () => {
            //以3结尾  从前往后去找2进行分组
            let targetTwoIndex = this.findLastIndex(
              containItem.reproduceItem,
              value => value.levelInfo === 2
            );
            let tempParagraphList = [];
            while (targetTwoIndex !== -1) {
              //得到由2和3构成的数组
              let twoAndThreeArr = containItem.reproduceItem.splice(
                targetTwoIndex,
                containItem.reproduceItem.length - targetTwoIndex
              );
              let tempBodyList = [];
              //判断3的类型，并构成bodyList
              for (let i = 1; i < twoAndThreeArr.length; i++) {
                // image: 5, //图片
                // video: 6, //视频
                // text: 7 //文本
                let content = twoAndThreeArr[i].detailedInfo;
                if (twoAndThreeArr[i].comprehensiveType === 5) {
                  //图片
                  tempBodyList.push({
                    type: 1,
                    content
                  });
                } else if (twoAndThreeArr[i].comprehensiveType === 6) {
                  //视频
                  tempBodyList.push({
                    type: 2,
                    content
                  });
                } else {
                  //文本
                  tempBodyList.push({
                    type: 4,
                    content: content === "尚未编辑内容" ? "" : content
                  });
                }
              }
              //bodyList加上当前的2构成tempParagraphList,需要判断2是目的地还是经验
              // destinationDatabase: 2, //数据库有的目的地
              // destinationCustom: 3, //用户自定义的目的地
              // experience: 4, //经验
              let paragraphItem = {};
              paragraphItem.bodyList = tempBodyList;
              paragraphItem.name = twoAndThreeArr[0].detailedInfo;
              if (twoAndThreeArr[0].comprehensiveType === 2) {
                //数据库有的目的地
                paragraphItem.type = 1;
                paragraphItem.dataTypeId = 2;
                paragraphItem.dataId = twoAndThreeArr[0].briefInfo;
                paragraphItem.lon = twoAndThreeArr[0].lon;
                paragraphItem.lat = twoAndThreeArr[0].lat;
              } else if (twoAndThreeArr[0].comprehensiveType === 3) {
                //自定义的目的地
                paragraphItem.type = 3;
              } else if (twoAndThreeArr[0].comprehensiveType === 4) {
                //经验
                paragraphItem.type = 2;
                paragraphItem.collapse = true;
              } else if (twoAndThreeArr[0].comprehensiveType === 8) {
                //空经验
                paragraphItem.type = 0;
              }
              tempParagraphList.unshift(paragraphItem); //因为是从后往前找的，所以使用unshit
              //继续去找2
              targetTwoIndex = this.findLastIndex(
                containItem.reproduceItem,
                value => value.levelInfo === 2
              );
            }
            //对最后的一个1的处理
            let nodeItem = {
              name: containItem.reproduceItem[0].detailedInfo,
              paragraphList: tempParagraphList,
              collapse: true,
              nameType: 1
            };
            dragNodeList.push(nodeItem);
          };
          //以3结尾（含有3肯定含有2）
          if (
            containItem.reproduceItem[containItem.reproduceItem.length - 1]
              .levelInfo === 3
          ) {
            formTheNodeList();
          } else {
            //Tips:以2结尾的处理方法 1232   123222
            //(step1):暂不考虑末尾的2 ,直到变为变为以3结尾的并处理它
            //(step2)：加上step1删除的最后一个2对应的结构
            let deleteTwoCollection = [];
            while (
              containItem.reproduceItem[containItem.reproduceItem.length - 1]
                .levelInfo !== 3
            ) {
              let deleteLastItem = containItem.reproduceItem.pop(); //重末尾删除
              deleteTwoCollection.push(deleteLastItem); //放到末尾
            }
            formTheNodeList();
            while (deleteTwoCollection.length !== 0) {
              let deleteLastItem = deleteTwoCollection.pop(); //从末尾弹出
              let anoterParagraphItem = {};
              anoterParagraphItem.bodyList = [];
              if (deleteLastItem.comprehensiveType === 2) {
                //如果是数据库已有的目的地
                anoterParagraphItem.type = 1;
                anoterParagraphItem.dataTypeId = 2; //实体类型
                anoterParagraphItem.name = deleteLastItem.detailedInfo;
                anoterParagraphItem.dataId = deleteLastItem.briefInfo;
                anoterParagraphItem.lon = deleteLastItem.lon;
                anoterParagraphItem.lat = deleteLastItem.lat;
              } else if (deleteLastItem.comprehensiveType === 3) {
                //如果是数据库没有的目的地
                anoterParagraphItem.type = 3;
                anoterParagraphItem.name = deleteLastItem.detailedInfo;
              } else if (deleteLastItem.comprehensiveType === 4) {
                //如果是经验
                anoterParagraphItem.type = 2;
                anoterParagraphItem.collapse = true;
                anoterParagraphItem.name = deleteLastItem.detailedInfo;
              } else if (deleteLastItem.comprehensiveType === 8) {
                //如果是经验
                anoterParagraphItem.type = 0;
                anoterParagraphItem.name = deleteLastItem.detailedInfo;
              }
              dragNodeList[dragNodeList.length - 1].paragraphList.push(
                anoterParagraphItem
              );
            }
          }
        } else if (containItem.hasTwo) {
          //不含有3但是含有2 即 1 2 或者 1 2 2 2的结构
          //Method:所有的2组成1的paragraphList
          let dragNodeItem = {};
          dragNodeItem.collapse = true;
          let dragNodeItemParagraphList = [];
          containItem.reproduceItem.forEach((currentValue, currentIndex) => {
            if (currentIndex === 0) {
              dragNodeItem.name = currentValue.detailedInfo;
            } else {
              let tempParagraphItem = {};
              tempParagraphItem.bodyList = [];
              if (currentValue.comprehensiveType === 2) {
                //如果是数据库已有的目的地
                tempParagraphItem.type = 1;
                tempParagraphItem.dataTypeId = 2; //实体类型
                tempParagraphItem.name = currentValue.detailedInfo;
                tempParagraphItem.dataId = currentValue.briefInfo;
                tempParagraphItem.lon = currentValue.lon;
                tempParagraphItem.lat = currentValue.lat;
              } else if (currentValue.comprehensiveType === 3) {
                //如果是数据库没有的目的地
                tempParagraphItem.type = 3;
                tempParagraphItem.name = currentValue.detailedInfo;
              } else if (currentValue.comprehensiveType === 4) {
                //如果是经验
                tempParagraphItem.type = 2;
                tempParagraphItem.collapse = true;
                tempParagraphItem.name = currentValue.detailedInfo;
              } else if (currentValue.comprehensiveType === 8) {
                //如果是经验
                tempParagraphItem.type = 0;
                tempParagraphItem.name = currentValue.detailedInfo;
              }
              dragNodeItemParagraphList.push(tempParagraphItem);
            }
          });
          dragNodeItem.paragraphList = dragNodeItemParagraphList;
          dragNodeList.push(dragNodeItem);
        } else {
          //只含有1 即 1
          let onlyOneDragItem = {
            name: containItem.reproduceItem[0].detailedInfo,
            paragraphList: [],
            collapse: true,
            nameType: 1
          };
          dragNodeList.push(onlyOneDragItem);
        }
      });
      this.form.nodeList = dragNodeList;
    },
    //取消图文混排
    cancleGraphicMixed() {
      this.txtGraphicsVisible = false;
    },
    //打开图文混排弹窗
    showTxtGraphics() {
      this.txtGraphicsVisible = true;
      //每一次拖拽List清空
      this.comprehensiveDragList = [];
      let comprehensiveTypeMap = {
        schedule: 1, //日程
        destinationDatabase: 2, //数据库有的目的地
        destinationCustom: 3, //用户自定义的目的地
        experience: 4, //经验
        image: 5, //图片
        video: 6, //视频
        text: 7, //文本
        nullExperience: 8 //空经验（用于包含日程下面的直接文本）
      };
      //第一层循环处理标题（写在前面和日程）
      for (
        let level1Index = 0;
        level1Index < this.form.nodeList.length;
        level1Index++
      ) {
        let tempLevel1Obj = this.form.nodeList[level1Index];
        //防止用户不可感知的日程显示出来
        if (tempLevel1Obj.name !== "") {
          this.comprehensiveDragList.push({
            comprehensiveType: comprehensiveTypeMap.schedule,
            briefInfo: "标",
            detailedInfo: tempLevel1Obj.name,
            levelInfo: 1
          });
        }
        //第二层循环处理处理经验和目的地(数据库有的和自定义的)
        for (
          let level2Index = 0;
          level2Index < tempLevel1Obj.paragraphList.length;
          level2Index++
        ) {
          let tempLevel2Obj = tempLevel1Obj.paragraphList[level2Index];
          //空二级不放（type=0），只放目的地和经验（type=1,2,3）
          if (tempLevel2Obj.type !== 0) {
            this.comprehensiveDragList.push({
              comprehensiveType:
                tempLevel2Obj.type === 1
                  ? comprehensiveTypeMap.destinationDatabase
                  : tempLevel2Obj.type === 2
                  ? comprehensiveTypeMap.experience
                  : comprehensiveTypeMap.destinationCustom,
              //如果是经验存放空串，如果是目的地则存放dataId
              briefInfo: tempLevel2Obj.type === 1 ? tempLevel2Obj.dataId : "",
              detailedInfo: tempLevel2Obj.name,
              levelInfo: 2,
              lon: tempLevel2Obj.lon ? tempLevel2Obj.lon : "",
              lat: tempLevel2Obj.lat ? tempLevel2Obj.lat : ""
            });
          }
          //第三层循环处理经验和目的地下面的
          for (
            let level3Index = 0;
            level3Index < tempLevel2Obj.bodyList.length;
            level3Index++
          ) {
            let tempLevel3Obj = tempLevel2Obj.bodyList[level3Index];
            this.comprehensiveDragList.push({
              //type 1 图片 2 视频 4 文本
              comprehensiveType:
                tempLevel3Obj.type === 1
                  ? comprehensiveTypeMap.image
                  : tempLevel3Obj.type === 2
                  ? comprehensiveTypeMap.video
                  : comprehensiveTypeMap.text,
              briefInfo: tempLevel3Obj.content ? tempLevel3Obj.content : "",
              detailedInfo: tempLevel3Obj.content
                ? tempLevel3Obj.content
                : "尚未编辑内容",
              levelInfo: 3
            });
          }
        }
      }
    },
    //选择本地文件
    selectLoaclFile() {
      //选择本地文件的时候开启自动上传
      this.autoUploadMulti = true;
    },
    //删除已经上传的图片
    delUploadImg(file) {
      let resultIndex = this.fileListMulti.findIndex(value => {
        return file.uid === value.uid;
      });
      this.fileListMulti.splice(resultIndex, 1);
      //如果当前上传列表长度为0，则也不可以点击确认按钮
      if (this.fileListMulti.length === 0) {
        this.disableInsertMultiImgs = true;
      }
      //删除图片后，如果文件列表长度小于5则可以继续上传图片
      if (this.fileListMulti.length < 5) {
        this.showInsertImgButton = true;
      }
    },
    //重新上传已经未成功上传的文件
    reUploadImg(file) {
      //取消自动上传，改为手动上传
      this.autoUploadMulti = false;
      //修改file的状态为ready
      file.status = "ready";
      this.$refs.mutiUpload.submit();
    },
    //上传文件个数超出限制
    handleExceed(files, fileList) {
      this.$message({
        message: "限制上传 5 张图片，请重新选择上传",
        type: "error",
        customClass: "high-zindex"
      });
    },
    //将base64转换为文件对象
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(",");
      var mime = arr[0].match(/:(.*?);/)[1];
      var bstr = atob(arr[1]);
      var n = bstr.length;
      var u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      //转换成file对象
      return new File([u8arr], filename, { type: mime });
    },
    cancleCropper() {
      this.showCropper = false;
      this.$nextTick(() => {
        // 以服务的方式调用的 Loading 需要异步关闭
        this.loadingInstance.close();
      });
    },
    submitCropper() {
      this.$nextTick(() => {
        // 以服务的方式调用的 Loading 需要异步关闭
        this.loadingInstance.close();
        //上传封面成功则修改是否上传过封面的变量
        this.hasUploadCover = true;
      });
      //生成裁剪和图片
      this.showCropper = false;
      this.$refs.cropper.getCropData(data => {
        let newFile = this.dataURLtoFile(
          data,
          `${this.moment(new Date()).format("YYYYMMDDHHmmSSS")}`
        );
        newFile.dirPath = "website/cover";
        this.uploadCropper(newFile);
      });
    },
    uploadCropper(file) {
      let that = this;
      return service
        .uploadFile({
          oemId: this.$cookie.get("userInfo_productId"),
          dirPath: file.dirPath,
          fileName: encodeURIComponent(`${file.name}.jpeg`)
        })
        .then(json => {
          if (json.respCode === 100) {
            let ajaxOption = {}; //上传最终文件的参数
            let downloadUrl = json.data.downloadUrl; //如果图片上传成功则为最终的图片下载地址
            ajaxOption.action = json.data.uploadUrl; //上传地址
            let tempData = {};
            let paramData = json.data.uploadFormDto;
            for (let key of Object.keys(paramData)) {
              tempData[key] = paramData[key];
            }
            ajaxOption.data = tempData; //上传文件的额外参数
            ajaxOption.file = file; //上传的文件
            ajaxOption.filename = "file"; //上传文件的文件名(有别于file.name,是上传文件接口要使用的)
            ajaxOption.onProgress = e => {
              console.log(e);
            };
            ajaxOption.onError = e => {
              console.log(e);
            };
            //成功的回调函数
            ajaxOption.onSuccess = e => {
              if (e === "success") {
                //调用成功后的回调函数
                that.form.imgsCut = downloadUrl; //裁剪后的图
                that.form.imgs = that.originalUrl; //原图
              }
            };
            //发送ajax请求
            uploadFileAjax(ajaxOption);
          } else {
            // Promise.reject();
            this.$message.error("上传文件失败!");
          }
        });
    },
    openAttribute() {
      this.showAttributeEdit = true;
    },
    checkPlayWay(playWayNode) {
      this.playWaydata = playWayNode.value;
      //首先看再不在数组中，如果在则删除，如果不在则加入
      let resultIndex = this.playTypeIdList.findIndex((value, index, arr) => {
        return value.typeId === this.playWaydata;
      });
      if (resultIndex === -1) {
        if (this.playTypeIdList.length === 3) {
          Global.messageErr("最多选择3项!");
          return;
        } else {
          this.playTypeIdList.push({ typeId: this.playWaydata });
        }
      } else {
        // 如果在数组中则删除
        this.playTypeIdList.splice(resultIndex, 1);
      }
    },
    checkInPlayWay(value) {
      let result = this.playTypeIdList.some(item => {
        return item.typeId === value;
      });
      return result;
    },
    checkDifficult(difficultNode) {
      this.difficulty = difficultNode.code;
    },
    checkPartner(partnerNode) {
      this.tourPar = partnerNode.code;
    },
    validate() {
      return this.ruleForm.playDays && this.ruleForm.price;
    },
    editContinue() {
      if (!this.validate()) {
        this.modalVisible = true;
      } else {
        this.travelAttributeData({
          beginDate: this.beginDate,
          playTypeIdList: this.playTypeIdList,
          tourPar: this.tourPar,
          playDays: this.ruleForm.playDays,
          price: this.ruleForm.price,
          totalMileage: this.ruleForm.totalMileage,
          difficulty: this.difficulty
        });
        this.showAttributeEdit = false;
      }
    },
    ...mapActions("WriteDataStore", ["getDataTypeList"]), //自驾玩法
    ...mapActions("NewTravelStore", [
      "findtrevelNotesdetail",
      "findTravelDetailOld"
    ]),
    ...mapMutations("WriteDataStore", [
      "writeDataMutation",
      "mergeData",
      "travelAttributeData"
    ]),
    //随机文本产生器
    randomText(index, j) {
      return index === 0 && j === 0
        ? "在路上，从不缺少难忘的美好……"
        : "向大家推荐一下这里吧……";
    },
    //通用的删除节点方法
    commonDelNode(itemschild, bodyList) {
      for (let i = 0, iLen = bodyList.length; i < iLen; i++) {
        if (itemschild === bodyList[i]) {
          bodyList.splice(i, 1);
        }
      }
    },
    //删除文本
    deleteText(index, j, realItemschild, itemschild, bodyList) {
      this.$confirm("此操作将删除该文本, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      })
        .then(() => {
          this.commonDelNode(itemschild, bodyList);
          if (
            realItemschild.type === 0 &&
            realItemschild.bodyList.length === 0
          ) {
            this.form.nodeList[index]["paragraphList"].splice(j, 1);
          }
        })
        .catch(() => {});
    },
    //删除图片
    deleteImg(itemschild, bodyList) {
      this.$confirm("此操作将删除该图片, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      })
        .then(() => {
          this.commonDelNode(itemschild, bodyList);
        })
        .catch(() => {});
    },
    //删除视频
    deleteVideo(itemschild, bodyList) {
      this.$confirm("此操作将删除该视频, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      })
        .then(() => {
          this.commonDelNode(itemschild, bodyList);
        })
        .catch(() => {});
    },
    nodeClickPatch(showTarget) {
      let naviArr = document.querySelectorAll(".naviTarget");
      naviArr = Array.prototype.slice.call(naviArr);
      naviArr.forEach(targetNavi => {
        targetNavi.children[0].children[1].classList.remove("checked-ball");
        targetNavi.children[1].classList.remove("checked-text");
      });
      this.$refs[showTarget][0].children[0].children[1].classList.add(
        "checked-ball"
      );
      this.$refs[showTarget][0].children[1].classList.add("checked-text");
    },
    nodeClick(e, items, index) {
      this.naviChecked = index;
      this.naviChildChecked = "~";
      window.scrollTo(0, this.$refs[`node${index}`][0].offsetTop);
      this.nodeClickPatch(`navi${index}`);
    },
    nodechildClick(e, index, j) {
      this.naviChecked = "~";
      this.naviChildChecked = `${index}${j}`;
      window.scrollTo(0, this.$refs[`nodechild${index}${j}`][0].offsetTop);
      this.nodeClickPatch(`navi${index}${j}`);
    },
    collapseToggle(items, index) {
      items.collapse = !items.collapse;
    },
    collapseToggleChild(itemschild, index, j) {
      itemschild.collapse = !itemschild.collapse;
    },
    importTransform() {
      return import("@/assets/images/travel/cover-default.png");
    },
    imageMappingDestination() {
      return require("@/assets/images/icons/type/scenic.png");
    },
    imageMapping(value) {
      if (this.imageOfType[value]) {
        return this.imageOfType[value];
      }
      return require("@/assets/images/icons/type/usercustom.png"); //自定义经验图标
    },
    handleScroll() {
      //获取监听的正文dom对象
      let monitoArr = document.querySelectorAll(".monitorTarget");
      //对NodeList应用Array的方法
      monitoArr = Array.prototype.slice.call(monitoArr);
      //找到首个top大于0的 （首个内容完整的）
      let naviIndex = monitoArr.findIndex(targetEle => {
        //获得dom的矩形区域
        let rect = targetEle.getBoundingClientRect();
        return rect.top > 0;
      });
      //获取监听的右侧目录dom对象
      let naviArr = document.querySelectorAll(".naviTarget");
      naviArr = Array.prototype.slice.call(naviArr);
      naviArr.forEach((targetNavi, index) => {
        if (index === naviIndex) {
          targetNavi.children[0].children[1].classList.add("checked-ball");
          targetNavi.children[1].classList.add("checked-text");
        } else {
          targetNavi.children[0].children[1].classList.remove("checked-ball");
          targetNavi.children[1].classList.remove("checked-text");
        }
      });
    },
    // getScrollTop() {
    //   let scroll_top = 0;
    //   if (document.documentElement && document.documentElement.scrollTop) {
    //       scroll_top = document.documentElement.scrollTop;
    //   }
    //   else if (document.body) {
    //       scroll_top = document.body.scrollTop;
    //   }
    //   return scroll_top;
    // }
    handleAvatarSuccess() {},
    beforeAvatarUpload() {},
    //封面图片
    addimg() {
      this.flag = "";
    },
    //编辑日程
    editDay(items, payload, index) {
      this.$set(items, "dayName", items.name);
      if (!items.editDayVisible) {
        this.$set(items, "editDayVisible", true);
      } else {
        items.editDayVisible = true;
      }
      this.$nextTick(() => {
        this.$refs[`day_edit_form${index}`][0].clearValidate();
      });
    },
    //保存日程
    saveDay(items, index, payload) {
      this.$refs[`day_edit_form${index}`][0].validate(valid => {
        if (valid) {
          items.editDayVisible = false;
          items.name = payload;
          this.dayFlag = 1;
        } else {
          return false;
        }
      });
    },
    closeDay(items, payload) {
      if (this.dayFlag === 1) {
        this.dayFlag === 0;
        return;
      } else {
        items.dayName = items.name;
      }
    },
    //删除日程
    removeDay(items, index) {
      //删除行程的第一天不让删除
      if (index === 0) {
        return;
      }
      const deleteConfirm = title => {
        this.$confirm(title, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消"
        })
          .then(() => {
            for (let i = 0, iLen = this.form.nodeList.length; i < iLen; i++) {
              if (this.form.nodeList[i] === items) {
                this.form.nodeList.splice(i, 1);
              }
            }
          })
          .catch(() => {});
      };
      if (
        items.paragraphList &&
        items.paragraphList.length > 0 &&
        items.paragraphList[0].bodyList.length > 0
      ) {
        deleteConfirm("确认要删除辛苦编辑的内容吗?");
      } else {
        //如果不存子节点则简单提示
        deleteConfirm("此操作将删除该日程, 是否继续?");
      }
    },
    //添加节点
    addnode(items, index) {
      if (!items.paragraphList) {
        this.$set(items, "paragraphList", []);
      }
      let tempChild = {
        fileList: [],
        bodyList: [], //节点
        dataId: "", //实体id
        dataTypeId: "", //实体类型
        name: "", //1.地点2.攻略
        type: 1, //1.地点2.攻略
        videoList: [],
        List: [{ value: "无数据", label: "无数据" }],
        collapse: true,
        DestinationVisible: true
      };
      items.paragraphList.push(tempChild);
      //给当前目的地弹窗赋值
      this.currentDestinationDialog = {
        title: "添加目的地",
        itemschild: tempChild,
        index: index,
        j: items.paragraphList.length - 1
      };
    },
    //目的地(搜索到下拉数据)弹窗添加按钮/经验的添加
    dialogaddNode(itemschild, index, j) {
      let that = this;
      // 经验数据type是2 系统能够检索到的目的地type是1,检索不到的是3
      this.$refs[
        itemschild.type === 2 ? `experience${index}` : `destination${index}`
      ].validate(valid => {
        if (valid) {
          itemschild.DestinationVisible = false;
          itemschild.ThemeVisible = false;
          itemschild.NewThemeVisible = false;
          itemschild.visibleflag = 1;
          that.form.nodeList[index].paragraphList[j].name = itemschild.name;
          that.form.nodeList[index].paragraphList[j].dataId = itemschild.dataId;
        } else {
          return false;
        }
      });
    },
    //目的地（没搜索到下拉数据）弹窗新建按钮
    dialognewNode(itemschild, index, j) {
      this.$refs[`destination${index}`].validate(valid => {
        document.querySelectorAll(
          ".el-autocomplete-suggestion"
        )[0].style.display = "none";
        if (valid) {
          this.form.nodeList[index].paragraphList[j].type = 3;
          itemschild.DestinationVisible = false;
          itemschild.ThemeVisible = false;
          itemschild.visibleflag = 1;
          this.form.nodeList[index].paragraphList[j].name = itemschild.name;
          this.form.nodeList[index].paragraphList[j].dataId = itemschild.dataId;
        } else {
          return false;
        }
      });
    },
    closeTheme(itemschild, index, j) {
      if (itemschild.visibleflag === 1) {
        itemschild.visibleflag = 0;
        return;
      } else {
        this.deleteFromParagraphList(itemschild, index, j);
      }
    },
    quickThemeCheck(itemschild, index, j, k) {
      if (this.childrenList.length > 0) {
        document.getElementsByClassName("check-bar")[0].children[
          this.childrenList[0]
        ].className = "";
        this.childrenList = [];
      }
      itemschild.name = this.list[k];
      this.childrenList.push(k);
      document.getElementsByClassName("check-bar")[0].children[
        this.childrenList[0]
      ].className = "check-on";
      //选择完某个经验之后就保存
      this.dialogaddNode(itemschild, index, j);
    },
    //目的地的编辑
    editNode(itemschild, index, j) {
      //当前目的地节点赋值
      if (itemschild.type === 1) {
        //采用ES6属性简写的方式
        this.currentDestinationDialog = {
          title: "编辑目的地",
          itemschild,
          index,
          j
        };
      }
      //当前经验节点赋值
      if (itemschild.type === 2) {
        this.currentExperienceDialog = {
          title: "编辑经验",
          itemschild,
          index,
          j
        };
      }
      //当前编辑节点的变化
      itemschild.visibleflag = 1;
      itemschild.DestinationVisible = true;
      itemschild.ThemeVisible = true;
      // 如果编辑的是经验则清空校验提示
      if (itemschild.type === 2) {
        this.$nextTick(() => {
          this.$refs[`experience${index}`].clearValidate();
        });
      }
    },
    // 新建目的地的编辑
    editNewNode(itemschild, index, j) {
      //当前目的节点赋值
      this.currentExperienceDialog = {
        title: "编辑目的地",
        itemschild,
        index,
        j
      };
      //当前节点的变化
      itemschild.DestinationVisible = true;
      itemschild.visibleflag = 1;
      // 目的地是新建的数据
      this.$set(itemschild, "NewThemeVisible", true);
    },
    //删除段落
    deleteFromParagraphList(itemschild, index, j) {
      for (let i = 0; i < this.form.nodeList[index].paragraphList.length; i++) {
        if (this.form.nodeList[index].paragraphList[j] === itemschild) {
          this.form.nodeList[index].paragraphList.splice(j, 1);
        }
      }
    },
    //目的地的删除
    deleteNode(itemschild, indexParam, jParam) {
      //如果不存在bodyList属性，需要为其设置一个
      if (!itemschild.bodyList) {
        this.$set(itemschild, "bodyList", []);
      }
      const deleteNodeConfirm = (title, index, j) => {
        this.$confirm(title, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消"
        })
          .then(() => {
            this.deleteFromParagraphList(itemschild, index, j);
          })
          .catch(() => {});
      };
      // 下面没有子节点
      if (itemschild.bodyList.length === 0) {
        if (itemschild.type === 2) {
          deleteNodeConfirm("此操作将删除该经验,是否继续?", indexParam, jParam);
        }
        if (itemschild.type === 3 || itemschild.type === 1) {
          // type为3是检索不到用户自己加的
          // type为1是能够检索到的
          deleteNodeConfirm(
            "此操作将删除该目的地,是否继续?",
            indexParam,
            jParam
          );
          //如果是删除数据库已有的目的地则删除对应的track中对应的经纬度
        }
      } else {
        deleteNodeConfirm("确认要删除辛苦编辑的内容吗?", indexParam, jParam);
      }
    },
    //目的地关闭时删除
    closeNode(itemschild, index, j) {
      if (itemschild.type === 1) {
        this.$refs[
          `destination${this.currentDestinationDialog.index}`
        ].clearValidate();
      } else if (itemschild.type === 2) {
        this.$refs[
          `experience${this.currentExperienceDialog.index}`
        ].clearValidate();
      }
      if (itemschild.visibleflag === 1) {
        itemschild.visibleflag = 0;
        return;
      } else {
        this.deleteFromParagraphList(itemschild, index, j);
      }
    },
    //添加主题
    addtheme(items, index) {
      if (!items.paragraphList) {
        this.$set(items, "paragraphList", []);
      }
      let tempChild = {
        fileList: [],
        bodyList: [], //节点
        dataId: "", //实体id
        dataTypeId: "", //实体类型
        name: "", //1.地点2.攻略
        type: 2, //1.地点2.攻略
        videoList: [],
        collapse: false,
        ThemeVisible: true
      };
      items.paragraphList.push(tempChild);
      this.currentExperienceDialog = {
        title: "添加经验",
        itemschild: tempChild,
        index,
        j: items.paragraphList.length - 1
      };
    },
    //增加日程
    addschedule(index, j) {
      let tempSchedule = {
        name: `自定义日程`,
        dayName: "自定义日程",
        nameType: 1,
        paragraphList: [],
        labelname: "日程",
        editDayVisible: false,
        collapse: false
      };
      if (j === undefined) {
        //在当前元素的后面增加一个日程（插入）
        this.form.nodeList.splice(index + 1, 0, tempSchedule);
      } else {
        //在最后面的元素增加一个日程 （追加）
        this.form.nodeList.push(tempSchedule);
      }
    },
    //远程搜索游玩地
    remoteMethod(query, cb) {
      let that = this;
      if (query !== "") {
        this.searchLoading = true;
        service
          .remote({
            word: query,
            dataType: 2,
            flag: 1 //搜索方式：按名称搜索
          })
          .then(json => {
            if (
              json.respCode === 100 &&
              json.data !== undefined &&
              json.data.data
            ) {
              //判断时编辑还是新建，后台返回的无List
              if (
                that.form.nodeList[that.nodeListIndexs.index].paragraphList[
                  that.nodeListIndexs.childIndex
                ].List
              ) {
                //清空下拉列表
                that.form.nodeList[that.nodeListIndexs.index].paragraphList[
                  that.nodeListIndexs.childIndex
                ].List = [];
                if (json.data.data.length > 0) {
                  json.data.data.forEach(item => {
                    that.form.nodeList[that.nodeListIndexs.index].paragraphList[
                      that.nodeListIndexs.childIndex
                    ].List.push({
                      label: item.id,
                      value: item.name,
                      lon: item.lon,
                      lat: item.lat
                    });
                  });
                } else {
                  that.form.nodeList[that.nodeListIndexs.index].paragraphList[
                    that.nodeListIndexs.childIndex
                  ].List.push({
                    label: "无数据",
                    value: "无数据"
                  });
                  setTimeout(() => {
                    let div = document.querySelectorAll(
                      ".el-autocomplete-suggestion"
                    );
                    if (div[0].outerText === "无数据") {
                      div[0].getElementsByTagName("li")[0].style.cursor =
                        "not-allowed";
                      var fm = div[0].getElementsByTagName("li")[0];
                      fm.addEventListener("change", test);
                      function test(e) {
                        e.preventDefault();
                      }
                    }
                  }, 0);
                }
              } else {
                this.$set(
                  this.form.nodeList[this.nodeListIndexs.index].paragraphList[
                    this.nodeListIndexs.childIndex
                  ],
                  "List",
                  []
                );
                json.data.data.forEach(item => {
                  that.form.nodeList[that.nodeListIndexs.index].paragraphList[
                    that.nodeListIndexs.childIndex
                  ].List.push({
                    label: item.id,
                    value: item.name,
                    lon: item.lon,
                    lat: item.lat
                  });
                });
              }
              var results =
                that.form.nodeList[that.nodeListIndexs.index].paragraphList[
                  that.nodeListIndexs.childIndex
                ].List;
              // clearTimeout(this.timeout);
              // this.timeout = setTimeout(() => {
              cb(results);
              // }, 1000 * Math.random());
            } else {
            }
          });
      } else {
        that.form.nodeList[that.nodeListIndexs.index].paragraphList[
          that.nodeListIndexs.childIndex
        ].List = [];
      }
    },
    //获得焦点的时候触发
    selectChange(value, index, j) {
      this.nodeListIndexs = {
        index: index,
        childIndex: j
      };
    },
    //选中改变的时候触发
    nameChange(e) {
      this.form.nodeList[this.nodeListIndexs.index].paragraphList[
        this.nodeListIndexs.childIndex
      ].name = e.value;
      this.form.nodeList[this.nodeListIndexs.index].paragraphList[
        this.nodeListIndexs.childIndex
      ].dataId = e.label;
      if (e.value !== "无数据") {
        this.form.nodeList[this.nodeListIndexs.index].paragraphList[
          this.nodeListIndexs.childIndex
        ].dataTypeId = 2;
        this.form.nodeList[this.nodeListIndexs.index].paragraphList[
          this.nodeListIndexs.childIndex
        ].lon = e.lon; //存储经度
        this.form.nodeList[this.nodeListIndexs.index].paragraphList[
          this.nodeListIndexs.childIndex
        ].lat = e.lat; //存储维度
      }
    },
    dialogAddTheme(itemschild, index, j) {
      itemschild.ThemeVisible = false;
      itemschild.visibleflag = 1;
      this.form.nodeList[index].paragraphList[j].name = itemschild.name;
    },
    //添加图片
    addimgfuction(itemschild, index, j) {
      if (!itemschild.bodyList) {
        this.$set(itemschild, "bodyList", []);
      }
      let tempImgChild = {
        type: 1,
        imgVisible: true,
        display: this.deleteImgNoDisplay,
        visibleflag: 0
      };
      itemschild.bodyList.push(tempImgChild);
      this.currentImageDialog = {
        itemschildchild: tempImgChild,
        index,
        j,
        z: itemschild.bodyList.length - 1,
        itemschild
      };
    },
    //不上传图片关闭
    closeImg(itemschildchild, index, j, z) {
      if (itemschildchild.visibleflag) {
        itemschildchild.visibleflag = 0;
        return;
      } else {
        let tempParagraph = this.form.nodeList[index].paragraphList[j];
        for (let i = 0; i < tempParagraph.bodyList.length; i++) {
          if (tempParagraph.bodyList[z] === itemschildchild) {
            tempParagraph.bodyList.splice(z, 1);
          }
        }
      }
      this.fileListMulti = [];
      this.showInsertImgButton = true;
    },
    //添加多张图片
    addMuitiImgs(i, j, z) {
      this.nodeListIndexs = {
        index: i,
        childIndex: j,
        childchildIndex: z
      };
      //把上传成功的图片插入到正文文本中
      this.fileListMulti.forEach((file, index, arr) => {
        this.$set(
          this.form.nodeList[this.nodeListIndexs.index].paragraphList[
            this.nodeListIndexs.childIndex
          ].bodyList[this.nodeListIndexs.childchildIndex],
          "content",
          file.url
        );
        this.form.nodeList[this.nodeListIndexs.index].paragraphList[
          this.nodeListIndexs.childIndex
        ].bodyList[this.nodeListIndexs.childchildIndex].imgVisible = false;
        this.$set(
          this.form.nodeList[this.nodeListIndexs.index].paragraphList[
            this.nodeListIndexs.childIndex
          ].bodyList[this.nodeListIndexs.childchildIndex],
          "visibleflag",
          1
        );
        //多个文件并且不是最后一个文件
        if (arr.length > 1 && index < arr.length - 1) {
          this.nodeListIndexs.childchildIndex++;
          let tempImgChild = {
            type: 1,
            imgVisible: true,
            display: this.deleteImgNoDisplay,
            visibleflag: 0
          };
          this.form.nodeList[this.nodeListIndexs.index].paragraphList[
            this.nodeListIndexs.childIndex
          ].bodyList.push(tempImgChild);
        }
      });
      //每次上传清空上传的多张图片
      this.fileListMulti = [];
      //再次上传图片时禁止确认按钮
      this.disableInsertMultiImgs = true;
    },
    //添加图片/视频/文本
    addimgs(i, j, z, flag) {
      this.disableInsertMultiImgs = true;
      this.showInsertImgButton = true;
      this.nodeListIndexs = {
        index: i,
        childIndex: j,
        childchildIndex: z
      };
      this.flag = flag;
    },
    showProcess() {
      this.currentDialogContent.loading = true;
      this.currentDialogContent.button = false;
    },
    hideProcess() {
      this.currentDialogContent.loading = false;
      this.currentDialogContent.button = true;
    },
    handleSuccess(response, file) {
      this.imageLoading.close();
      this.hideProcess();
      Global.messageSuc("上传成功");
      file.url = this.fileBasePath;
      // flag 如果为空为上传封面  flag如果为1则为上传图片 flag如果为2则上传的是视频
      if (this.flag === "") {
        this.showCropper = true; //显示裁剪组件
        this.downloadUrl = ""; //每次显示裁剪组件的时候，裁切图片下载地址重置
        this.originalUrl = file.url; //上传的原始图片
        this.option.img = file.url; //给裁剪组件配置图片
        //显示遮罩层
        this.loadingInstance = Loading.service({
          fullscreen: true,
          spinner: "no-named-spinner", //传一个不存在的spinner类名
          background: "rgba(0, 0, 0, 0.8)"
        });
      } else if (this.flag === 2) {
        this.isShowUploadVideo = true;
        this.videoFlag = false;
        this.videoUploadPercent = 0;
        let levelIndex1 = this.nodeListIndexs.index;
        let levelIndex2 = this.nodeListIndexs.childIndex;
        let levelIndex3 = this.nodeListIndexs.childchildIndex;
        this.form.nodeList[levelIndex1].paragraphList[levelIndex2].bodyList[
          levelIndex3
        ].content = file.url;
        this.form.nodeList[levelIndex1].paragraphList[
          levelIndex2
        ].videoList.push(file);
        this.form.nodeList[levelIndex1].paragraphList[levelIndex2].bodyList[
          levelIndex3
        ].videoVisible = false;
        this.$set(
          this.form.nodeList[levelIndex1].paragraphList[levelIndex2].bodyList[
            levelIndex3
          ],
          "visibleflag",
          1
        );
      }
    },
    beforeUploadMulti(file) {
      this.disableInsertMultiImgs = true;
      const isIMG =
        file.type === "image/jpg" ||
        file.type === "image/jpeg" ||
        file.type === "image/png";
      if (!isIMG) {
        this.$message.error("上传图片只支持jpg、jpeg、png格式!");
        return false;
      }
      const isLt = file.size < 5 * 1024 * 1024;
      if (!isLt) {
        this.$message.error("图片超出5M，瘦身后再上传吧！");
        return false;
      } else {
        let param = {
          oemId: this.$cookie.get("userInfo_productId"),
          dirPath: `${this.$cookie.get("userInfo_productId")}${
            this.fileDirPath
          }`,
          fileName: encodeURIComponent(file.name)
        };
        return uploadUtils.prepareConfig(param, this, file);
      }
    },
    hideInsertButton() {
      if (this.fileListMulti.length === 5) {
        this.showInsertImgButton = false;
      }
    },
    handleProgressMulti(event, file, fileList) {
      this.fileListMulti = fileList;
      this.hideInsertButton();
    },
    handleErrorMulti(err, file, fileList) {
      this.fileListMulti = fileList;
      this.hideInsertButton();
    },
    handleChangeMulti(file, fileList) {
      this.fileListMulti = fileList;
      this.hideInsertButton();
    },
    handleSuccessMulti(response, file, fileList) {
      file.url = file.raw.downloadUrl;
      this.fileListMulti = fileList;
      this.hideInsertButton();
      this.disableInsertMultiImgs = !this.fileListMulti.every(file => {
        return file.status === "success";
      });
      // 自动上传的时候模拟一个失败的
      // if (this.autoUploadMulti) {
      //   this.fileListMulti[0].status = "fail";
      //   this.fileListMulti[1].status = "uploading";
      // }
    },
    beforeUpload(file) {
      let canUpload = true; //控制是否可以上传文件
      if (this.flag === 1 || this.flag === "") {
        const isIMG =
          file.type === "image/jpg" ||
          file.type === "image/jpeg" ||
          file.type === "image/png";
        if (!isIMG) {
          this.$message.error("上传图片只支持jpg、jpeg、png格式!");
          return false;
        }
        const isLt = file.size < 5 * 1024 * 1024;
        if (!isLt) {
          canUpload = false;
          this.$message.error("图片超出5M，瘦身后再上传吧！");
          return false;
        }
      } else if (this.flag === 2) {
        var fileSize = file.size / 1024 / 1024 < 25;
        if (!fileSize) {
          canUpload = false;
          this.$message.error("视频超标啦，再浓缩精剪一下吧！");
          return false;
        }
        this.isShowUploadVideo = false;
      } else if (this.flag === 3) {
        let fileName = file.name;

        let pos = fileName.lastIndexOf(".");

        let lastName = fileName.substring(pos, fileName.length);

        if (lastName.toLowerCase() !== ".txt") {
          canUpload = false;
          this.$message.error("请上传.txt文件类型");
        }
      }
      if (canUpload) {
        this.imageLoading = this.$loading({
          fullscreen: true
        });
        let param = {
          oemId: this.$cookie.get("userInfo_productId"),
          dirPath: `${this.$cookie.get("userInfo_productId")}${
            this.fileDirPath
          }`,
          fileName: encodeURIComponent(file.name)
        };

        return uploadUtils.prepareConfig(param, this, file);
      }
    },
    //添加视频
    addvideofuction(itemschild, index, j) {
      if (!itemschild.bodyList) {
        this.$set(itemschild, "bodyList", []);
      }
      //从编辑页回来如果上次编辑没有添加视频本次添加的时候会报错
      //所以先检查一下如果不存在属性，先设置一个
      if (!itemschild.videoList) {
        this.$set(itemschild, "videoList", []);
      }
      let tempVideoChild = {
        type: 2,
        videoVisible: true,
        display: this.deleteImgNoDisplay,
        visibleflag: 0
      };
      itemschild.bodyList.push(tempVideoChild);
      this.currentVideoDialog = {
        itemschildchild: tempVideoChild,
        index,
        j,
        z: itemschild.bodyList.length - 1,
        itemschild
      };
    },
    //进度条
    uploadVideoProcess(event, file, fileList) {
      this.showProcess();
      this.videoFlag = true;
      this.videoUploadPercent = Number(file.percentage.toFixed(0));
    },
    //主添加文本
    addtext(index, j) {
      if (j === undefined) {
        this.form.nodeList[index].paragraphList.push({
          fileList: [],
          bodyList: [
            {
              type: 4,
              display: this.deleteImgNoDisplay
            }
          ], //节点
          dataId: "", //实体id
          dataTypeId: "", //实体类型
          name: "", //1.地点2.攻略
          type: 0, //1:地点 2:攻略 0:直接隶属于某一日程的文本
          typecopy: 0,
          videoList: [],
          List: []
        });
      } else {
        if (!this.form.nodeList[index].paragraphList[j].bodyList) {
          this.$set(this.form.nodeList[index].paragraphList[j], "bodyList", []);
        }
        this.form.nodeList[index].paragraphList[j].bodyList.push({
          type: 4,
          display: this.deleteImgNoDisplay
        });
      }
    },
    //保存之前的参数准备工作
    prepareSave(state) {
      this.form.compositionType = 2; //游记
      this.form.state = state; //2.保存3.发布
      this.form.userId = this.$cookie.get("userInfo_userId");
      this.form = Object.assign(this.form, this.writeData);
    },
    async Release() {
      if (!this.form.name) {
        this.noTitle = true;
      } else {
        this.noTitle = false;
      }
      if (!this.form.name && !this.form.imgs) {
        this.$message("你好像把封面和标题遗忘了，设置一下再来发布吧!");
        return;
      } else if (this.form.name && !this.form.imgs) {
        this.$message("给游记设置一个好看的封面，再来发布吧!");
        return;
      } else if (!this.form.name && this.form.imgs) {
        this.$message("没有标题的游记它不完整，写了标题再发布吧!");
        return;
      }
      this.text = 1;
      this.prepareSave(1); //2.保存 1.发布（后端为了区分来源是网站还是工具把类型又改为1）
      //所有图片转换
      const realRelease = () => {
        this.handleTrack();
        service.save(this.form, "info/saveTravelNote").then(json => {
          if (json.respCode === 100 && json.respCode !== undefined) {
            this.$router.push({ name: "success" });
          }
        });
      };
      await this.handeleCoverImage(realRelease); //参数为1表示发布
    },
    //预览
    async Preview() {
      this.text = 1;
      this.prepareSave(2); //2.保存3.发布
      //所有图片转换
      const realPreview = () => {
        this.handleTrack();
        service.save(this.form, "info/saveTravelNote").then(json => {
          if (json.respCode === 100 && json.respCode !== undefined) {
            this.travelAttributeData({});
            // this.writeDataMutation(this.form);
            // window.localStorage.setItem("id", json.data);
            this.$router.push({ path: `/preview/${json.data}` }).catch(e => {});
          }
        });
      };
      await this.handeleCoverImage(realPreview); //参数为2表示预览
    },
    //退出页面
    async SaveExit() {
      this.prepareSave(2); //2.保存3.发布
      const realSaveExit = () => {
        this.handleTrack();
        service.save(this.form, "info/saveTravelNote").then(json => {
          if (json.respCode === 100 && json.respCode !== undefined) {
            // this.writeDataMutation(this.form);
            this.$message.success("已保存至我的草稿");
            this.travelAttributeData({});
            window.localStorage.setItem("id", json.data);
          }
        });
      };
      //所有图片转换
      await this.handeleCoverImage(realSaveExit); //参数为3表示退出保存
    },
    //查询的数据加上删除的属性
    deleteFlag(form) {
      for (let i = 0; i < form.nodeList.length; i++) {
        if (!form.nodeList[i].paragraphList) {
          this.$set(form.nodeList[i], "paragraphList", []);
        }
        for (let j = 0; j < form.nodeList[i].paragraphList.length; j++) {
          if (!form.nodeList[i].paragraphList[j].bodyList) {
            this.$set(form.nodeList[i].paragraphList[j], "bodyList", []);
          }
          for (
            let z = 0;
            z < form.nodeList[i].paragraphList[j].bodyList.length;
            z++
          ) {
            this.$set(
              form.nodeList[i].paragraphList[j].bodyList[z],
              "display",
              {
                position: "absolute",
                right: "695px",
                display: "none"
              }
            );
          }
        }
      }
    },
    visibleFlag(form) {
      for (let i = 0; i < form.nodeList.length; i++) {
        for (let j = 0; j < form.nodeList[i].paragraphList.length; j++) {
          this.$set(
            form.nodeList[i].paragraphList[j],
            "DestinationVisible",
            false
          );
          this.$set(
            form.nodeList[i].paragraphList[j],
            "NewThemeVisible",
            false
          );
          this.$set(form.nodeList[i].paragraphList[j], "ThemeVisible", false);
          this.$set(form.nodeList[i].paragraphList[j], "visibleflag", 0);
          this.$set(form.nodeList[i].paragraphList[j], "collapse", false);
        }
      }
    },
    collapse(form) {
      for (let i = 0; i < form.nodeList.length; i++) {
        this.$set(form.nodeList[i], "collapse", true);
      }
    }
  },
  created() {
    //游记属性
    this.getDataTypeList({ type: 4 });
    document.title = "游记编辑_自驾出游好帮手_鹿驾网";
    let id = this.$route.params.id;
    if (id && id !== "new") {
      this.findTravelDetailOld({ id });
    }
    this.pageflag = window.localStorage.getItem("flag");
    //如果是由预览页返回到编辑页
    if (this.pageflag === "back") {
      this.form = {};
      this.form = this.backData;
      this.deleteFlag(this.form);
      this.visibleFlag(this.form);
    } else if (this.pageflag === "") {
      this.mergeData(); //获取前一页的数据
    } else if (this.pageflag === "draft") {
      this.deleteFlag(this.form);
      this.visibleFlag(this.form);
      this.form = this.backData;
    }
    this.$root.showWriteBall = false;
    this.$eventHub.$on("windowScroll", data => {
      if (data.scrollTop > 600) {
        if (data.scrollBottom < 290) {
          this.tNaviStyle = {
            position: "fixed",
            bottom: `${(document.documentElement.clientHeight ||
              document.body.clientHeight) - 420}px`,
            left: `${this.$refs.tNavi.offsetLeft}px`
          };
        } else {
          this.tNaviStyle = {
            position: "fixed",
            top: "0px",
            left: `${this.$refs.tNavi.offsetLeft}px`
          };
        }
      } else {
        this.tNaviStyle = {};
      }
    });
  },
  beforeDestroy() {
    if (this.text === 1) {
      this.text = 0;
    } else {
      this.SaveExit();
    }
  }
};
</script>
<style lang="less">
@import "~@/lesses/main/travel/index.less";
@import "~@/lesses/main/travel/travel-attribute.less";
@import "~@/lesses/main/travel/txt-graphic.less";
.modal-container {
  .el-form-item {
    margin-bottom: 0px;
  }
}
.main-page {
  .edit_day_form {
    .el-form-item__error {
      left: 73px;
    }
  }
  .add_destination_form {
    .el-form-item__error {
      left: 73px;
    }
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
}
.el-autocomplete-suggestion__list {
  li {
    margin-bottom: 10px;
  }
}
.high-zindex {
  z-index: 4000;
}
</style>
